import React, { useEffect, useState } from "react";
import { listTimetableWeeks, getChamCongThangThuNhap, getChamCongThangTuTKB, getKhaoSatTongHop, saveChamCongTuTKBAdjust, setGopTuTkb, getCustomTable, getChamCongGvcnNghe, getPcKiemXe, savePcKiemXe, savePcKiemXeDs, getCongDaoTao, saveCongDaoTao, getBangLuong, saveBangLuong, saveTreoLuong, getNgheXangXe, saveNgheXangXe, getChamCongNghe, getChamCongThangPublish, setChamCongThangPublish } from "./happyschoolApi";
import * as XLSX from "xlsx";
import { CONG_DAO_TAO_COLS, parseCongDaoTao, TAM_UNG_COLS, QTKD_COLS, parseBangChuyenKhoan, parseChamCongDaoTao, ANTRUA_DON_GIA } from "./congDaoTaoParse";
import { getActiveSchoolId } from "./activeSchool";
import HappySchoolDataTable from "./HappySchoolDataTable";
import HappySchoolPublishLog from "./HappySchoolPublishLog";
import { exportTableExcel } from "./excelExport";

const ExportBtn = ({ onClick, disabled }) => (
  <button type="button" onClick={onClick} disabled={disabled}
    style={{ padding: "7px 14px", background: "#0ea5a3", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer", fontWeight: 600, fontSize: 13 }}>
    ⬇ Export Excel
  </button>
);

// YYYY-MM-DD -> DD/MM
function fmt(d) {
  if (!d) return "";
  const p = String(d).split("-");
  return p.length === 3 ? `${p[2]}/${p[1]}` : d;
}
const monthKeyOf = (dateStr) => String(dateStr || "").slice(0, 7); // "YYYY-MM"
const monthLabelOf = (monthKey) => `Tháng ${Number(monthKey.slice(5, 7))}/${monthKey.slice(0, 4)}`;
const vnd = (n) => Number(n || 0).toLocaleString("vi-VN");

// tableKey của bảng tháng 8 giữ nguyên "chamcongThang8" (đã có sẵn dữ liệu gõ
// tay từ trước) — các tháng sau dùng tableKey riêng theo tháng.
const CHAMCONG_THANG8_KEY = "chamcongThang8";
const tableKeyForMonth = (monthKey) => (monthKey === "2026-08" ? CHAMCONG_THANG8_KEY : `chamcongThang_${monthKey.replace("-", "_")}`);

// Tháng 8 dùng đúng mẫu cũ (đã có dữ liệu, cột cố định theo 4 tuần đã biết
// từ trước khi có hệ thống TKB); các tháng khác tự sinh 1 cột "Tuần ..."
// theo đúng số tuần TKB thật có trong tháng đó.
const CHAMCONG_THANG8_CFG = {
  title: "Chấm công tháng — GV Văn hoá",
  columns: [
    { key: "stt", label: "STT", width: 50 },
    { key: "hoten", label: "Họ và tên", width: 180 },
    { key: "bomon", label: "Bộ môn", width: 110 },
    { key: "loai", label: "Loại", width: 120 },
    { key: "tuan1", label: "Tuần 03-08 (tiết)", width: 120 },
    { key: "tuan2", label: "Tuần 10-15 (tiết)", width: 120 },
    { key: "tuan3", label: "Tuần 17/08–22/08 (tiết)", width: 150 },
    { key: "tuan4", label: "Tuần 24/08–30/08 (tiết)", width: 150 },
    { key: "tongtiet", label: "Tổng tiết", width: 90 },
    { key: "thanhtien", label: "Thành tiền", width: 120 },
    { key: "hotroTinHoc", label: "Hỗ trợ GV tin học", width: 140 },
  ],
  totalColumns: ["tuan1", "tuan2", "tuan3", "tuan4", "tongtiet", "thanhtien", "hotroTinHoc"],
  publishable: true,
};
const buildMonthChamCongCfg = (monthKey, weeksOfMonth) => {
  if (monthKey === "2026-08") return CHAMCONG_THANG8_CFG;
  const tuanCols = weeksOfMonth.map((w, i) => ({ key: `tuan${i + 1}`, label: `Tuần ${fmt(w.startDate)}–${fmt(w.endDate)} (tiết)`, width: 150 }));
  return {
    title: `Chấm công tháng — GV Văn hoá (${monthLabelOf(monthKey)})`,
    columns: [
      { key: "stt", label: "STT", width: 50 },
      { key: "hoten", label: "Họ và tên", width: 180 },
      { key: "bomon", label: "Bộ môn", width: 110 },
      { key: "loai", label: "Loại", width: 120 },
      ...tuanCols,
      { key: "tongtiet", label: "Tổng tiết", width: 90 },
      { key: "thanhtien", label: "Thành tiền", width: 120 },
    ],
    totalColumns: [...tuanCols.map((tc) => tc.key), "tongtiet", "thanhtien"],
    publishable: true,
  };
};

// Cấu hình 3 bảng "Khảo sát" — mỗi bảng đúng 1 sheet của file Excel đề xuất
// thanh toán chế độ khảo sát (không theo tháng TKB, đứng độc lập trong tab
// con "Khảo sát" của trang này).
const kc = (key, label, width = 130) => ({ key, label, width });
const KHAO_SAT_CFG = {
  khaoSatLan1K12: {
    title: "Khảo sát — Lần 1 Khối 12 (tính vào Thu nhập tháng 10/2026)", icon: "📝", publishable: true, totalColumns: ["thucnhan"],
    columns: [kc("hoten", "Họ và tên", 170), kc("nhiemvu", "Nhiệm vụ", 180), kc("soluong", "Số lượng", 90),
      kc("sotien", "Đơn giá", 100), kc("thucnhan", "Thực nhận", 110), kc("loaihdld", "Loại HĐLĐ", 130), kc("trangthai", "Trạng thái", 130), kc("ghichu", "Ghi chú", 150)],
  },
  khaoSatLan2K10: {
    title: "Khảo sát — Lần 2 Khối 10", icon: "📝", publishable: true, totalColumns: ["thucnhan"],
    columns: [kc("hoten", "Họ và tên", 170), kc("nhiemvu", "Nhiệm vụ", 180), kc("soluong", "Số lượng", 90),
      kc("sotien", "Đơn giá", 100), kc("thucnhan", "Thực nhận", 110), kc("loaihdld", "Hình thức HĐLĐ", 120), kc("ghichu", "Ghi chú", 150)],
  },
  khaoSatLan3K12: {
    title: "Khảo sát — Lần 3 Khối 12", icon: "📝", publishable: true, totalColumns: ["thucnhan"],
    columns: [kc("hoten", "Họ và tên", 170), kc("nhiemvu", "Nhiệm vụ", 180), kc("soluong", "Số lượng", 90),
      kc("sotien", "Đơn giá", 100), kc("thucnhan", "Thực nhận", 110), kc("kynhan", "Kí nhận", 90),
      kc("loaihdld", "Loại HĐLĐ", 130), kc("ghichu", "Ghi chú", 150)],
  },
  khaoSatLan4K12: {
    title: "Khảo sát — Lần 4 Khối 12", icon: "📝", publishable: true, totalColumns: ["thucnhan"],
    columns: [kc("hoten", "Họ và tên", 170), kc("nhiemvu", "Nhiệm vụ", 180), kc("soluong", "Số lượng", 90),
      kc("sotien", "Đơn giá", 100), kc("thucnhan", "Thực nhận", 110), kc("loaihdld", "Loại HĐLĐ", 130), kc("ghichu", "Ghi chú", 150)],
  },
};
const KHAO_SAT_INNER_TABS = [
  { key: "khaoSatLan1K12", label: "Lần 1 Khối 12 (T10)" },
  { key: "khaoSatLan2K10", label: "Lần 2 Khối 10" },
  { key: "khaoSatLan3K12", label: "Lần 3 Khối 12" },
  { key: "khaoSatLan4K12", label: "Lần 4 Khối 12" },
  { key: "tonghop", label: "Tổng hợp" },
];

const SUB_TABS = [
  { key: "chamcong", label: "🧾 Xem chấm công" },
  { key: "tutkb", label: "📋 Chấm công theo TKB" },
  { key: "ngoaitkb", label: "📋 Chấm công ngoài TKB" },
  { key: "nghe", label: "🛠 Chấm công GV Nghề" },
  { key: "thunhapnghe", label: "💵 Thu nhập GV Nghề" },
  { key: "thunhapthpt", label: "💵 Thu nhập THPT" },
  { key: "kiemxe", label: "🚗 Chấm công kiểm xe" },
  { key: "congdaotao", label: "🏫 Công Đào Tạo" },
  { key: "tamung", label: "💸 Tạm ứng lương" },
  { key: "qtkd", label: "🏢 QTKD" },
  { key: "antrua", label: "🍱 Ăn trưa Đào tạo" },
  { key: "khaosat", label: "📝 Khảo sát" },
  { key: "thunhap", label: "💵 Thu nhập" },
  { key: "treoluong", label: "⏸ Treo lương" },
  { key: "daotaonghe", label: "🏫🛠 Đào tạo + GV Nghề" },
];

// Tab "Chấm công ngoài TKB" — GV dạy Nghề/CNTT theo lớp Đại học, không nằm
// trong TKB K12 do CP-SAT xếp (VD Adobe Photoshop, Flash, Lắp ráp máy tính...)
// nên không tự suy tiết từ thời khoá biểu được — admin gõ tay TỪNG BUỔI DẠY
// THỰC TẾ (ngày/lớp/môn/tiết) làm bằng chứng chấm công, tách khỏi bảng tổng
// theo tuần "Xem chấm công" (Tuần 1-4) vốn chỉ có số tổng, không có chi tiết.
const CHAMCONG_NGOAI_TKB_KEY = "chamcongChiTietThang8";
const ngoaiTkbKeyForMonth = (monthKey) => (!monthKey || monthKey === "2026-08" ? CHAMCONG_NGOAI_TKB_KEY : `chamcongChiTietThang_${monthKey.replace("-", "_")}`);
const CHAMCONG_NGOAI_TKB_CFG = {
  title: "Chấm công ngoài TKB — theo từng buổi dạy",
  columns: [
    { key: "stt", label: "STT", width: 50 },
    { key: "ngay", label: "Ngày", width: 110 },
    { key: "buoi", label: "Buổi", width: 90 },
    { key: "hoten", label: "Họ và tên", width: 180 },
    { key: "lop", label: "Lớp", width: 90 },
    { key: "monhoc", label: "Môn học", width: 220 },
    { key: "tiet", label: "Tiết", width: 70 },
  ],
  totalColumns: ["tiet"],
  publishable: true,
};


// Bảng "Tổng tiết theo giáo viên" dưới bảng Chấm công ngoài TKB — cộng thẳng từ
// các dòng buổi dạy của bảng (bấm "Tải lại" sau khi sửa bảng) để lấy số tổng
// từng người dùng tính lương; công thức Excel (SUMIF) khi xuất file.
const NgoaiTkbTongTheoGV = ({ schoolId, tableKey, label }) => {
  const [rows, setRows] = useState(null);
  const [reload, setReload] = useState(0);
  useEffect(() => {
    if (!schoolId) return;
    setRows(null);
    getCustomTable(schoolId, tableKey).then((t) => setRows((t && Array.isArray(t.rows)) ? t.rows : [])).catch(() => setRows([]));
  }, [schoolId, tableKey, reload]);
  if (rows === null) return <p style={{ color: "#6b7280", fontSize: 13 }}>Đang tải tổng tiết...</p>;
  const by = {};
  rows.forEach((r) => {
    const n = String(r.hoten || "").trim(); if (!n) return;
    by[n] = by[n] || { hoten: n, tiet: 0, buoi: 0 };
    by[n].tiet += Number(r.tiet) || 0; by[n].buoi += 1;
  });
  const list = Object.values(by).sort((a, b) => a.hoten.localeCompare(b.hoten, "vi"));
  const tong = list.reduce((a, r) => a + r.tiet, 0);
  const exportExcel = () => exportTableExcel({
    title: `Tổng tiết theo giáo viên — Chấm công ngoài TKB — ${label}`, sheetName: "Tổng tiết", fileName: `tong_tiet_ngoai_tkb_${tableKey}.xlsx`,
    header: ["STT", "Họ và tên", "Số buổi", "Tổng tiết"],
    rows: list.map((r, i) => [i + 1, r.hoten, r.buoi, r.tiet]),
    totalRow: ["", "Tổng cộng", list.reduce((a, r) => a + r.buoi, 0), list.length ? { formula: `SUM(D3:D${2 + list.length})`, result: tong } : 0],
  });
  return (
    <div style={{ marginTop: 18 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
        <h4 style={{ margin: 0 }}>Tổng tiết theo giáo viên</h4>
        <button type="button" onClick={() => setReload((k) => k + 1)} style={{ padding: "4px 10px", border: "1px solid #d1d5db", borderRadius: 6, background: "#fff", cursor: "pointer", fontSize: 12 }}>↻ Tải lại</button>
        <span style={{ marginLeft: "auto" }}><ExportBtn onClick={exportExcel} disabled={list.length === 0} /></span>
      </div>
      {list.length === 0 ? <p style={{ color: "#6b7280", fontSize: 13 }}>Chưa có dòng nào.</p> : (
        <table style={{ borderCollapse: "collapse", fontSize: 13, minWidth: 360 }}>
          <thead><tr>{["STT", "Họ và tên", "Số buổi", "Tổng tiết"].map((h) => (<th key={h} style={{ border: "1px solid #e5e7eb", padding: "6px 10px", background: "#f9fafb", textAlign: h === "Họ và tên" ? "left" : "center" }}>{h}</th>))}</tr></thead>
          <tbody>
            {list.map((r, i) => (
              <tr key={r.hoten}>
                <td style={{ border: "1px solid #e5e7eb", padding: "6px 10px", textAlign: "center" }}>{i + 1}</td>
                <td style={{ border: "1px solid #e5e7eb", padding: "6px 10px", fontWeight: 600 }}>{r.hoten}</td>
                <td style={{ border: "1px solid #e5e7eb", padding: "6px 10px", textAlign: "center" }}>{r.buoi}</td>
                <td style={{ border: "1px solid #e5e7eb", padding: "6px 10px", textAlign: "center", fontWeight: 700, color: "#047857" }}>{r.tiet}</td>
              </tr>
            ))}
            <tr>
              <td style={{ border: "1px solid #e5e7eb", padding: "6px 10px", background: "#ecfdf5" }} colSpan={2}><b>Tổng cộng</b></td>
              <td style={{ border: "1px solid #e5e7eb", padding: "6px 10px", textAlign: "center", background: "#ecfdf5", fontWeight: 700 }}>{list.reduce((a, r) => a + r.buoi, 0)}</td>
              <td style={{ border: "1px solid #e5e7eb", padding: "6px 10px", textAlign: "center", background: "#ecfdf5", fontWeight: 700 }}>{tong}</td>
            </tr>
          </tbody>
        </table>
      )}
    </div>
  );
};


// Tab "Chấm công GV Nghề" — làm y hệt "Chấm công theo TKB" (Cơ hữu): Tiết chuẩn
// 4×17=68, Tiền = Lương cơ bản + Lương hiệu quả + 80.000 × Tiết vượt, nhưng
// Lương hiệu quả = 0 và Tổng số tiết = tổng tiết cộng từ bảng "Chấm công ngoài
// TKB" của tháng (không suy từ TKB K12).
const NGHE_LUONG_CO_BAN = 5700000;
const NGHE_LUONG_HIEU_QUA = 0; // mặc định
// Lương hiệu quả RIÊNG từng GV Nghề (khớp NGHE_LUONG_HIEU_QUA_DS bên happyschool-api).
const NGHE_LUONG_HIEU_QUA_DS = { "Hoàng Thị Khánh Linh": 500000 };
const ngheLhqOf = (hoten) => (Object.prototype.hasOwnProperty.call(NGHE_LUONG_HIEU_QUA_DS, hoten) ? NGHE_LUONG_HIEU_QUA_DS[hoten] : NGHE_LUONG_HIEU_QUA);
const NGHE_TIET_CHUAN = 68;
const NGHE_KHONG_TIN_HOC = ["Hoàng Văn Định", "Sạch Văn Mạnh"];
const NGHE_TRU_TIET_THIEU = ["Sạch Văn Mạnh"]; // tính theo tiết thực tế (có trừ tiết thiếu dưới 68)
// GV Nghề FULLTIME (khớp NGHE_FULLTIME bên happyschool-api): lương tháng cố định + xăng xe cố định.
const NGHE_FULLTIME = { "Hoàng Văn Dũng": { luong: 13000000, luongCoBan: 5700000, pcChuyenMon: 7300000, xangXe: 1000000, tuThang: "2026-09" } }; // luong = luongCoBan + pcChuyenMon // GV nghề không phải GV Tin học -> không có hỗ trợ Tin học
// Phụ cấp đào tạo (GV nghề kiêm đào tạo): 1.000.000đ/tháng; ai làm không đủ tháng thì
// chia theo ngày công thực tế / 26 ngày công chuẩn (Thuý làm đến 21/09 = 18 ngày làm).
const NGHE_PC_DAO_TAO = 1000000;
const NGHE_PC_DAO_TAO_DS = {
  "Phạm Ngô Thùy Dung": null,
  "Đặng Hồng Hải": null,
  "Hoàng Thị Khánh Linh": null,
};
// Phụ cấp kiểm xe: 1.000.000đ/tháng cho người được giao kiểm xe.
const PC_KIEM_XE_DON_GIA = 1000000;
const foldPc = (name) => String(name || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/gi, "d").toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_|_$/g, "");
const tienPcKiemXe = (soNgay, ngayCong) => (ngayCong > 0 ? Math.round(PC_KIEM_XE_DON_GIA * Math.min(soNgay, ngayCong) / ngayCong) : 0);
// Nhập "Số ngày kiểm xe" (bấm vào ô); để trống = 0 ngày (không có phụ cấp).
const nhapSoNgayKiemXe = async (schoolId, monthKey, hoten, hienTai, ngayCong) => {
  const v = window.prompt(`Số ngày kiểm xe của ${hoten} (tối đa ${ngayCong} = đủ tháng, trừ Chủ nhật; để trống = 0):`, String(hienTai));
  if (v === null) return false;
  try { await savePcKiemXe(schoolId, monthKey, hoten, v.trim() === "" ? null : v.trim()); return true; }
  catch (e) { window.alert(e.message || "Không lưu được."); return false; }
};
// GV Nghề không có hỗ trợ điện thoại GVCN (khớp NGHE_KHONG_DIEN_THOAI bên happyschool-api).
const NGHE_KHONG_DIEN_THOAI = ["pham_ngo_thuy_dung"];
const NGHE_HT_TINHOC = 1000000; // GV Tin học dạy đủ 68 tiết/tháng được 1.000.000đ, thiếu thì chia tỷ lệ
const parseNgayVN = (s) => { const m = String(s || "").match(/^(\d{2})\/(\d{2})\/(\d{4})$/); return m ? new Date(Date.UTC(+m[3], +m[2] - 1, +m[1])) : null; };
const weekKeyOf = (d) => { const t = new Date(d.getTime()); const day = (t.getUTCDay() + 6) % 7; t.setUTCDate(t.getUTCDate() - day); return t.toISOString().slice(0, 10); };
const ChamCongNgheTab = ({ schoolId, monthKey }) => {
  const tableKey = ngoaiTkbKeyForMonth(monthKey);
  const [rows, setRows] = useState(null);
  const [cnMap, setCnMap] = useState({});
  const [xxMap, setXxMap] = useState({});
  const [anMap, setAnMap] = useState({});
  const [reload, setReload] = useState(0);
  useEffect(() => {
    if (!schoolId) return;
    setRows(null);
    getNgheXangXe(schoolId, monthKey).then((d) => setXxMap(d.map || {})).catch(() => setXxMap({}));
    getBangLuong(schoolId, monthKey, "an-trua").then((d) => setAnMap(Object.fromEntries((((d.data || {}).rows) || []).map((x) => [foldPc(x.hoten), Number(x.tienAnTrua) || 0])))).catch(() => setAnMap({}));
    getCustomTable(schoolId, tableKey)
      .then((t) => {
        const rs = (t && Array.isArray(t.rows)) ? t.rows : [];
        setRows(rs);
        const names = [...new Set(rs.map((r) => String(r.hoten || "").trim()).filter(Boolean))];
        if (!names.length) return setCnMap({});
        return getChamCongGvcnNghe(schoolId, monthKey, names).then((d) => setCnMap(Object.fromEntries((d.rows || []).map((x) => [x.hoten, x])))).catch(() => setCnMap({}));
      })
      .catch(() => setRows([]));
  }, [schoolId, tableKey, monthKey, reload]);
  if (rows === null) return <p>Đang tải...</p>;
  const by = {};
  rows.forEach((r) => {
    const n = String(r.hoten || "").trim(); if (!n) return;
    const e = (by[n] = by[n] || { hoten: n, tiet: 0, weeks: new Set() });
    e.tiet += Number(r.tiet) || 0;
    const d = parseNgayVN(r.ngay); if (d) e.weeks.add(weekKeyOf(d));
  });
  const list = Object.values(by).sort((a, b) => a.hoten.localeCompare(b.hoten, "vi")).map((e) => {
    const c = cnMap[e.hoten] || {};
    const tietCN1 = Number(c.tietCN1) || 0, tietCN2 = Number(c.tietCN2) || 0;
    const htdt = NGHE_KHONG_DIEN_THOAI.includes(foldPc(e.hoten)) ? 0 : Number(c.tienDienThoai) || 0;
    const xangXe = Number((xxMap[foldPc(e.hoten)] || {}).soTien) || 0;
    const pcAn = anMap[foldPc(e.hoten)] || 0;
    const tong = e.tiet + tietCN1 + tietCN2;
    const donGia = Number(c.donGiaTietVuot) || DON_GIA_TIET_VUOT; // theo thâm niên (server)
    // Dạy dưới 68 tiết: KHÔNG trừ tiết thiếu (theo kế toán) — trừ người trong NGHE_TRU_TIET_THIEU.
    const truThieu = NGHE_TRU_TIET_THIEU.includes(e.hoten);
    const vuot = truThieu ? tong - NGHE_TIET_CHUAN : Math.max(0, tong - NGHE_TIET_CHUAN); const ltv = vuot * donGia;
    const laTinHoc = !NGHE_KHONG_TIN_HOC.includes(e.hoten);
    const htTinHoc = laTinHoc ? (truThieu ? Math.round(Math.min(1, e.tiet / NGHE_TIET_CHUAN) * NGHE_HT_TINHOC) : NGHE_HT_TINHOC) : 0;
    const lhq = ngheLhqOf(e.hoten);
    const tienChamCong = NGHE_LUONG_CO_BAN + lhq + ltv + htdt;
    const pcCfg = Object.prototype.hasOwnProperty.call(NGHE_PC_DAO_TAO_DS, e.hoten) ? NGHE_PC_DAO_TAO_DS[e.hoten] : undefined;
    const coPcDaoTao = pcCfg !== undefined;
    const pcDaoTao = !coPcDaoTao ? 0 : pcCfg ? Math.round(NGHE_PC_DAO_TAO * pcCfg.ngayLam / pcCfg.ngayThang) : NGHE_PC_DAO_TAO;
    const ft = NGHE_FULLTIME[e.hoten];
    if (ft && monthKey >= ft.tuThang) {
      const xx = xangXe || ft.xangXe || 0;
      return { hoten: e.hoten, fullTime: true, donGia, namThu: c.namThu ?? null, pcDaoTao: 0, pcCfg: null, laTinHoc: false, soTuan: e.weeks.size, tiet: e.tiet, htTinHoc: 0, xangXe: xx, pcAn, tongNhan: ft.luong + xx + pcAn, soLopCN: Number(c.soLopCN) || 0, lopCN1: c.lopCN1 || "", lopCN2: c.lopCN2 || "", tietCN1, tietCN2, htdt: 0, tong, vuot: 0, ltv: 0, lhq: 0, tien: ft.luong };
    }
    return { hoten: e.hoten, donGia, namThu: c.namThu ?? null, pcDaoTao, pcCfg, laTinHoc, soTuan: e.weeks.size, tiet: e.tiet, htTinHoc, xangXe, pcAn, tongNhan: tienChamCong + htTinHoc + pcDaoTao + xangXe + pcAn, soLopCN: Number(c.soLopCN) || 0, lopCN1: c.lopCN1 || "", lopCN2: c.lopCN2 || "", tietCN1, tietCN2, htdt, tong, vuot, ltv, lhq, tien: NGHE_LUONG_CO_BAN + lhq + ltv + htdt };
  });
  const sum = (k) => list.reduce((a, r) => a + r[k], 0);
  const n = list.length;
  const dash = (v) => (v ? v : "—");
  const exportExcel = () => {
    const header = ["Họ và tên", "Loại", "Số tuần có TKB", "Tiết thường", "Tiết TC", "Số lớp CN", "Tiết CN Lớp 1", "Lớp CN 1", "Tiết CN Lớp 2", "Lớp CN 2", "Số lớp dạy TN12", "Tổng số tiết (CK+TC+CN)", "Tiết tiêu chuẩn (4×17)", "Tiết vượt", "Lương cơ bản", "Lương hiệu quả", "Lương tiết vượt (theo thâm niên)", "Tiền TN12 (×100k)", "HT ĐT", "Tiền", "Hỗ trợ Tin học", "Phụ cấp đào tạo", "Xăng xe (dạy KV liên kết)", "PC Ăn (ăn trưa)", "Tổng nhận (Tiền + HT Tin học + PC đào tạo + Xăng xe + PC Ăn)"];
    const xr = list.map((r, i) => { const k = 3 + i; return [
      r.hoten, "GV Nghề", r.soTuan, r.tiet, 0, r.soLopCN || "", r.lopCN1 ? r.tietCN1 : "", r.lopCN1, r.lopCN2 ? r.tietCN2 : "", r.lopCN2, "",
      { formula: `SUM(D${k}:E${k},G${k},I${k})`, result: r.tong }, NGHE_TIET_CHUAN,
      { formula: `L${k}-M${k}`, result: r.vuot }, NGHE_LUONG_CO_BAN, r.lhq,
      { formula: `N${k}*${r.donGia}`, result: r.ltv }, "", r.htdt || "",
      { formula: `SUM(O${k}:S${k})`, result: r.tien },
      r.laTinHoc ? { formula: `ROUND(MIN(1,D${k}/${NGHE_TIET_CHUAN})*${NGHE_HT_TINHOC},0)` , result: r.htTinHoc } : 0, r.pcDaoTao ? (r.pcCfg ? { formula: `ROUND(${NGHE_PC_DAO_TAO}*${r.pcCfg.ngayLam}/${r.pcCfg.ngayThang},0)`, result: r.pcDaoTao } : NGHE_PC_DAO_TAO) : 0,
      r.xangXe || 0, r.pcAn || 0,
      { formula: `T${k}+U${k}+V${k}+W${k}+X${k}`, result: r.tongNhan }]; });
    const last = 2 + n; const cs = (L, v) => (n ? { formula: `SUM(${L}3:${L}${last})`, result: v } : 0);
    return exportTableExcel({
      title: `Chấm công GV Nghề — ${monthLabelOf(monthKey)}`, sheetName: "GV Nghề", fileName: `cham_cong_gv_nghe_${monthKey}.xlsx`, header, rows: xr,
      moneyCols: [14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
      totalRow: ["Tổng cộng", "", "", cs("D", sum("tiet")), 0, cs("F", sum("soLopCN")), cs("G", sum("tietCN1")), "", cs("I", sum("tietCN2")), "", "", cs("L", sum("tong")), "", "", cs("O", NGHE_LUONG_CO_BAN * n), cs("P", sum("lhq")), cs("Q", sum("ltv")), "", cs("S", sum("htdt")), cs("T", sum("tien")), cs("U", sum("htTinHoc")), cs("V", sum("pcDaoTao")), cs("W", sum("xangXe")), cs("X", sum("pcAn")), cs("Y", sum("tongNhan"))],
    });
  };
  const heads = ["Họ và tên", "Loại", "Số tuần có TKB", "Tiết thường", "Tiết TC", "Số lớp CN", "Tiết CN Lớp 1", "Tiết CN Lớp 2", "Số lớp dạy TN12", "Tổng số tiết (CK+TC+CN)", "Tiết tiêu chuẩn (4×17)", "Tiết vượt", "Lương cơ bản", "Lương hiệu quả", "Lương tiết vượt", "Tiền TN12 (×100k)", "HT ĐT", "Tiền", "Hỗ trợ Tin học", "Phụ cấp đào tạo", "Xăng xe (dạy KV liên kết)", "PC Ăn (ăn trưa)", "Tổng nhận (Tiền + HT Tin học + PC đào tạo + Xăng xe + PC Ăn)"];
  const printList = () => {
    const esc = (x) => String(x ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const m = (v) => (v ? Math.round(v).toLocaleString("vi-VN") : "");
    const body = list.map((r, i) => `<tr><td class="c">${i + 1}</td><td class="l b">${esc(r.hoten)}${r.fullTime ? " <i>(FullTime)</i>" : ""}</td>`
      + `<td class="c">${r.tiet}</td><td class="c">${(r.tietCN1 || 0) + (r.tietCN2 || 0) || ""}</td><td class="c b">${r.tong}</td><td class="c">${r.vuot}</td>`
      + `<td>${r.fullTime ? m(NGHE_FULLTIME[r.hoten].luongCoBan) : m(NGHE_LUONG_CO_BAN)}</td><td>${r.fullTime ? m(NGHE_FULLTIME[r.hoten].pcChuyenMon) : ""}</td><td>${m(r.lhq)}</td><td>${m(r.ltv)}</td><td>${m(r.htdt)}</td>`
      + `<td>${m(r.htTinHoc)}</td><td>${m(r.pcDaoTao)}</td><td>${m(r.xangXe)}</td><td>${m(r.pcAn)}</td><td class="b">${m(r.tongNhan)}</td></tr>`).join("");
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>Chấm công GV Nghề ${esc(monthLabelOf(monthKey))}</title>
<style>@page{size:A4 landscape;margin:8mm}body{font-family:"Times New Roman",serif;font-size:11px;color:#000}h2{text-align:center;margin:2px 0}.sub{text-align:center;margin:0 0 6px}
table{border-collapse:collapse;width:100%}th,td{border:1px solid #000;padding:3px 4px;text-align:right}th{background:#eee;text-align:center;font-size:10.5px}
td.l{text-align:left}td.c{text-align:center}.b{font-weight:bold}tr{page-break-inside:avoid}thead{display:table-header-group}.tot td{background:#f3f3f3;font-weight:bold}
.sign{display:flex;justify-content:space-around;margin-top:16px;text-align:center}.sign div{width:30%}</style></head><body>
<div style="font-weight:bold">TRƯỜNG TRUNG CẤP KINH TẾ - KỸ THUẬT PHAN CHU TRINH</div>
<h2>BẢNG CHẤM CÔNG GIÁO VIÊN NGHỀ</h2><p class="sub">${esc(monthLabelOf(monthKey))}</p>
<table><thead><tr><th>STT</th><th>Họ và tên</th><th>Tiết thường</th><th>Tiết CN</th><th>Tổng tiết</th><th>Tiết vượt (−${NGHE_TIET_CHUAN})</th><th>Lương cơ bản</th><th>PC chuyên môn</th><th>Lương hiệu quả</th><th>Lương tiết vượt</th><th>HT ĐT GVCN</th><th>HT Tin học</th><th>PC đào tạo</th><th>Xăng xe</th><th>PC Ăn</th><th>Tổng nhận</th></tr></thead>
<tbody>${body}<tr class="tot"><td></td><td class="l">Tổng cộng (${n} người)</td><td class="c">${sum("tiet")}</td><td class="c">${sum("tietCN1") + sum("tietCN2")}</td><td class="c">${sum("tong")}</td><td></td><td></td><td></td><td>${m(sum("lhq"))}</td><td>${m(sum("ltv"))}</td><td>${m(sum("htdt"))}</td><td>${m(sum("htTinHoc"))}</td><td>${m(sum("pcDaoTao"))}</td><td>${m(sum("xangXe"))}</td><td>${m(sum("pcAn"))}</td><td>${m(sum("tongNhan"))}</td></tr></tbody></table>
<div class="sign"><div><b>Người lập bảng</b><br><i>(Ký, ghi rõ họ tên)</i></div><div><b>Kế toán</b><br><i>(Ký, ghi rõ họ tên)</i></div><div><i>Ngày ...... tháng ...... năm ${esc(String(monthKey).slice(0, 4))}</i><br><b>Hiệu trưởng</b><br><i>(Ký, ghi rõ họ tên)</i></div></div>
<script>window.onload=function(){setTimeout(function(){window.print()},200)}</script></body></html>`;
    const w = window.open("", "_blank");
    if (!w) { window.alert("Trình duyệt chặn cửa sổ in — cho phép popup rồi bấm lại."); return; }
    w.document.open(); w.document.write(html); w.document.close();
  };
  const suaXangXe = async (r) => {
    const v = window.prompt(`Xăng xe (hỗ trợ dạy KV liên kết) của ${r.hoten} — ${monthLabelOf(monthKey)} (để trống = 0):`, r.xangXe ? String(r.xangXe) : "");
    if (v === null) return;
    try { await saveNgheXangXe(schoolId, monthKey, r.hoten, v.trim() === "" ? null : v.trim()); setReload((k) => k + 1); } catch (e) { window.alert(e.message || "Không lưu được."); }
  };
  const tot = { background: "#ecfdf5", fontWeight: 700 };
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
        <p style={{ color: "#6b7280", fontSize: 13, margin: 0, flex: 1 }}>
          Giáo viên Nghề — tính như Cơ hữu: Tiền = Lương cơ bản {vnd(NGHE_LUONG_CO_BAN)} + Lương hiệu quả (mặc định 0; cô Khánh Linh 500.000) + Đơn giá × (Tổng số tiết − {NGHE_TIET_CHUAN}) + HT ĐT — đơn giá tiết vượt theo thâm niên công tác: năm 1 = 80.000, năm 2 = 82.000, năm 3 = 85.000, năm 4+ = 90.000. Phụ cấp đào tạo: Dung, Hải, Linh 1.000.000đ/tháng; (cô Minh Thuý không có). Phụ cấp kiểm xe tính ở tab riêng "Kiểm xe". Thầy Hoàng Văn Dũng FullTime (từ 9/2026): lương 13.000.000 + xăng xe 1.000.000, không tính theo tiết. Cô Dung không có HT ĐT. Cột Xăng xe bấm để sửa. Dạy dưới 68 tiết vẫn đủ lương cơ bản + đủ HT Tin học (không trừ tiết thiếu), trừ thầy Sạch Văn Mạnh tính theo tiết thực tế. Hỗ trợ Tin học (chỉ GV Tin học, thầy Định không có): dạy đủ 68 tiết = 1.000.000đ/tháng, thiếu thì chia tỷ lệ (tách riêng, không nằm trong Tiền). Tiết thường lấy từ bảng "Chấm công ngoài TKB" của tháng; GVCN: lớp 1 = 2 tiết/tuần, lớp 2 = 4 tiết/tuần (cộng vào Tổng số tiết), HT ĐT 200.000/lớp CN.
        </p>
        <button type="button" onClick={() => setReload((k) => k + 1)} style={{ padding: "4px 10px", border: "1px solid #d1d5db", borderRadius: 6, background: "#fff", cursor: "pointer", fontSize: 12 }}>↻ Tải lại</button>
        <button type="button" onClick={printList} disabled={n === 0} style={{ padding: "5px 12px", border: "1px solid #374151", borderRadius: 6, background: "#fff", color: "#374151", cursor: n ? "pointer" : "not-allowed", fontSize: 13, fontWeight: 600 }}>🖨 In</button>
        <ExportBtn onClick={exportExcel} disabled={n === 0} />
      </div>
      {n === 0 ? <p style={{ color: "#6b7280" }}>Tháng này chưa có dòng nào trong bảng "Chấm công ngoài TKB".</p> : (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8 }}>
          <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%" }}>
            <thead><tr>{heads.map((h) => (<th key={h} style={{ ...th, textAlign: h === "Họ và tên" ? "left" : "center" }}>{h}</th>))}</tr></thead>
            <tbody>
              {list.map((r) => (
                <tr key={r.hoten}>
                  <td style={{ ...td, textAlign: "left", fontWeight: 600 }}>{r.hoten}</td>
                  <td style={td}>{r.fullTime ? "GV Nghề (FullTime)" : "GV Nghề"}</td>
                  <td style={td}>{r.soTuan}</td>
                  <td style={td}>{r.tiet}</td>
                  <td style={td}>0</td>
                  <td style={td} title={[r.lopCN1, r.lopCN2].filter(Boolean).join(", ")}>{dash(r.soLopCN)}</td>
                  <td style={td}>{r.lopCN1 ? `${r.tietCN1} (${r.lopCN1})` : "—"}</td>
                  <td style={td}>{r.lopCN2 ? `${r.tietCN2} (${r.lopCN2})` : "—"}</td>
                  <td style={td}>—</td>
                  <td style={{ ...td, fontWeight: 700 }}>{r.tong}</td>
                  <td style={td}>{NGHE_TIET_CHUAN}</td>
                  <td style={{ ...td, color: r.vuot > 0 ? "#0f766e" : r.vuot < 0 ? "#dc2626" : undefined }}>{r.vuot}</td>
                  <td style={td}>{r.fullTime ? `${vnd(NGHE_FULLTIME[r.hoten].luongCoBan)} + PC chuyên môn ${vnd(NGHE_FULLTIME[r.hoten].pcChuyenMon)} (FullTime)` : vnd(NGHE_LUONG_CO_BAN)}</td>
                  <td style={td}>{r.lhq ? vnd(r.lhq) : "—"}</td>
                  <td style={td} title={`${r.namThu ? `Năm thứ ${r.namThu} — ` : ""}${vnd(r.donGia)}/tiết`}>{vnd(r.ltv)}</td>
                  <td style={td}>—</td>
                  <td style={td}>{r.htdt ? vnd(r.htdt) : "—"}</td>
                  <td style={{ ...td, fontWeight: 700, color: "#047857" }}>{vnd(r.tien)}</td>
                  <td style={td} title="Dạy đủ 68 tiết = 1.000.000đ, thiếu thì chia tỷ lệ">{r.laTinHoc ? vnd(r.htTinHoc) : "—"}</td>
                  <td style={td} title={r.pcCfg ? `Làm ${r.pcCfg.ngayLam}/${r.pcCfg.ngayThang} ngày: ${vnd(NGHE_PC_DAO_TAO)} × ${r.pcCfg.ngayLam}/${r.pcCfg.ngayThang}` : "1.000.000đ/tháng"}>{r.pcDaoTao ? vnd(r.pcDaoTao) : "—"}</td>
                  <td style={{ ...td, cursor: "pointer", textDecoration: "underline dotted" }} title="Bấm để sửa" onClick={() => suaXangXe(r)}>{r.xangXe ? vnd(r.xangXe) : "—"}</td>
                  <td style={td} title="Từ tab Ăn trưa Đào tạo (10.000đ/ngày làm trọn)">{r.pcAn ? vnd(r.pcAn) : "—"}</td>
                  <td style={{ ...td, fontWeight: 700, color: "#047857" }}>{vnd(r.tongNhan)}</td>
                </tr>
              ))}
              <tr>
                <td style={{ ...td, ...tot, textAlign: "left" }} colSpan={2}>Tổng cộng</td>
                <td style={{ ...td, ...tot }} />
                <td style={{ ...td, ...tot }}>{sum("tiet")}</td>
                <td style={{ ...td, ...tot }}>0</td>
                <td style={{ ...td, ...tot }}>{sum("soLopCN")}</td>
                <td style={{ ...td, ...tot }}>{sum("tietCN1")}</td>
                <td style={{ ...td, ...tot }}>{sum("tietCN2")}</td>
                <td style={{ ...td, ...tot }} />
                <td style={{ ...td, ...tot }}>{sum("tong")}</td>
                <td style={{ ...td, ...tot }} colSpan={2} />
                <td style={{ ...td, ...tot }}>{vnd(NGHE_LUONG_CO_BAN * n)}</td>
                <td style={{ ...td, ...tot }}>{sum("lhq") ? vnd(sum("lhq")) : "—"}</td>
                <td style={{ ...td, ...tot }}>{vnd(sum("ltv"))}</td>
                <td style={{ ...td, ...tot }}>—</td>
                <td style={{ ...td, ...tot }}>{vnd(sum("htdt"))}</td>
                <td style={{ ...td, ...tot, fontSize: 15, color: "#047857" }}>{vnd(sum("tien"))}</td>
                <td style={{ ...td, ...tot }}>{vnd(sum("htTinHoc"))}</td>
                <td style={{ ...td, ...tot }}>{vnd(sum("pcDaoTao"))}</td>
                <td style={{ ...td, ...tot }}>{vnd(sum("xangXe"))}</td>
                <td style={{ ...td, ...tot }}>{vnd(sum("pcAn"))}</td>
                <td style={{ ...td, ...tot, fontSize: 15, color: "#047857" }}>{vnd(sum("tongNhan"))}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};


// Tab "Chấm công kiểm xe" — danh sách người được giao kiểm xe (LƯU DATABASE, dùng chung
// mọi tháng, thêm/bỏ ngay trên tab); PC kiểm xe = 1.000.000 × Số ngày kiểm xe / (số ngày
// của tháng trừ Chủ nhật). Số ngày để trống = 0; bấm vào ô để sửa.
// Tab "Công Đào Tạo" — bảng lương khối Ban giám hiệu / Phòng đào tạo / Bếp / Bảo vệ, lấy từ file Excel
// kế toán "BẢNG LƯƠNG THÁNG ..." (sheet "Lương _Đào tạo"). Admin bấm "📥 Nhập từ Excel" để nạp/ghi đè tháng.
const CongDaoTaoTab = ({ schoolId, monthKey }) => {
  const [data, setData] = useState(undefined);
  const [busy, setBusy] = useState(false);
  const [reload, setReload] = useState(0);
  useEffect(() => {
    if (!schoolId) return;
    getCongDaoTao(schoolId, monthKey).then((d) => setData(d.data || null)).catch(() => setData(null));
  }, [schoolId, monthKey, reload]);
  const nhapFile = async (e) => {
    const f = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!f) return;
    setBusy(true);
    try {
      const wb = XLSX.read(await f.arrayBuffer());
      const ten = wb.SheetNames.find((x) => /đào\s*tạo/i.test(x.normalize("NFC"))) || wb.SheetNames[0];
      const r = parseCongDaoTao(XLSX.utils.sheet_to_json(wb.Sheets[ten], { header: 1, raw: true, defval: null }));
      if (!r.rows.length) throw new Error("Không đọc được dòng nào.");
      if (data && !window.confirm(`Ghi đè dữ liệu Công Đào Tạo ${monthLabelOf(monthKey)} bằng ${r.rows.length} dòng từ "${f.name}" (sheet "${ten}")?`)) return;
      await saveCongDaoTao(schoolId, monthKey, { ...r, nguon: f.name.normalize("NFC") });
      setReload((k) => k + 1);
    } catch (err) { window.alert(err.message || "Không nhập được file."); } finally { setBusy(false); }
  };
  if (data === undefined) return <p>Đang tải...</p>;
  // Hoàn về = Số tiền CK (nhập riêng) − Thực lĩnh, chỉ với dòng có Số tiền CK.
  const rows = ((data && data.rows) || []).map((r) => (Number(r.soTienCK) > 0 ? { ...r, hoanVe: Math.round(Number(r.soTienCK) - (Number(r.thucLinh) || 0)) } : r));
  const cols = CONG_DAO_TAO_COLS.filter((c) => c.key !== "mnv");
  const moneyCols = cols.filter((c) => c.money);
  const tong = {};
  moneyCols.forEach((c) => { tong[c.key] = rows.reduce((a, r) => a + (Number(r[c.key]) || 0), 0); });
  const cell = (r, c) => (c.money ? (r[c.key] ? vnd(r[c.key]) : "") : (r[c.key] ?? ""));
  // Công thức Excel (chỉ ghi khi khớp số trên web, lệch thì giữ số): Lương theo ngày công, Tổng phụ cấp,
  // Tổng thu nhập, Tổng phải trừ, Thực lĩnh, Hoàn về.
  const ix = (k) => { const i = cols.findIndex((c) => c.key === k); return i < 0 ? -1 : i + 2; };
  const sumRefs = (refs) => `SUM(${refs.join(",")})`;
  const tongN = (n) => n.reduce((a, b) => a + b, 0);
  const pcKeys = ["pcDungLop", "pcChuyenMon", "pcDienThoai", "pcChucVu", "pcXangXe", "pcAn", "pcKhac"].map(ix).filter((i) => i >= 0);
  const cdtRowFormulas = [
    { col: ix("luongNgayCong"), refs: [ix("luongCoBan"), ix("congThucTe"), ix("congThoaThuan")], f: ([a, b, c]) => `ROUND(${a}*${b}/${c},0)`, calc: ([a, b, c]) => (c ? Math.round((a * b) / c) : NaN) },
    { col: ix("pcTong"), refs: pcKeys, f: sumRefs, calc: tongN },
    { col: ix("tongThuNhap"), refs: ["luongNgayCong", "pcTong", "quaTang", "quaTangNT"].map(ix), f: sumRefs, calc: tongN },
    { col: ix("tongPhaiTru"), refs: ["bhxh", "congDoan", "thueTNCN", "truKhac"].map(ix), f: sumRefs, calc: tongN },
    { col: ix("thucLinh"), refs: ["tongThuNhap", "tongPhaiTru", "phiNganHang", "tamUng"].map(ix), f: ([t, ...tru]) => `${t}-SUM(${tru.join(",")})`, calc: ([t, ...tru]) => t - tongN(tru) },
    { col: ix("hoanVe"), refs: ["soTienCK", "thucLinh"].map(ix), f: ([a, b]) => `${a}-${b}`, calc: ([a, b]) => a - b },
  ].filter((rf) => rf.col >= 0 && rf.refs.every((i) => i >= 0));
  const exportExcel = () => exportTableExcel({
    title: `Công Đào Tạo — ${monthLabelOf(monthKey)}`, sheetName: "Công Đào Tạo", fileName: `cong_dao_tao_${monthKey}.xlsx`,
    header: ["STT", "Bộ phận", ...cols.map((c) => c.label)],
    rows: rows.map((r, i) => [i + 1, r.nhom || "", ...cols.map((c) => (c.money || c.num ? (r[c.key] ?? "") : (r[c.key] || "")))]),
    moneyCols: cols.map((c, i) => (c.money ? i + 2 : -1)).filter((i) => i >= 0),
    totalRow: ["", "Tổng cộng", ...cols.map((c) => (c.money ? tong[c.key] : ""))],
    rowFormulas: cdtRowFormulas,
  });
  // 🖨 In bảng Công Đào Tạo (A4 ngang), giữ nhóm bộ phận + dòng tổng.
  const printList = () => {
    const esc = (x) => String(x ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const money = (v) => (Number(v) ? Math.round(Number(v)).toLocaleString("vi-VN") : "");
    const pcols = cols.filter((c) => c.key !== "ghiChu" && c.key !== "ghiChuPhuCap" && c.key !== "ghiChuKhauTru");
    let nt = null; let stt = 0;
    const body = rows.map((r) => {
      let h = "";
      if (r.nhom && r.nhom !== nt) { h = `<tr><td colspan="${pcols.length + 1}" class="l b grp">${esc(r.nhom)}</td></tr>`; }
      nt = r.nhom; stt += 1;
      return h + `<tr><td class="c">${stt}</td>${pcols.map((c) => `<td class="${c.money || c.num ? "" : "l"}${c.key === "hoten" || c.key === "thucLinh" ? " b" : ""}">${esc(c.money ? money(r[c.key]) : (r[c.key] ?? ""))}</td>`).join("")}</tr>`;
    }).join("");
    const foot = `<tr class="tot"><td></td>${pcols.map((c) => `<td class="${c.money ? "" : "l"} b">${c.key === "hoten" ? "Tổng cộng" : c.money ? money(tong[c.key]) : ""}</td>`).join("")}</tr>`;
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>Công Đào Tạo ${esc(monthLabelOf(monthKey))}</title>
<style>@page{size:A4 landscape;margin:8mm}body{font-family:"Times New Roman",serif;font-size:10px;color:#000}h2{text-align:center;margin:2px 0}.sub{text-align:center;margin:0 0 6px}
table{border-collapse:collapse;width:100%}th,td{border:1px solid #000;padding:2px 3px;text-align:right}th{background:#eee;text-align:center;font-size:9px}
td.l{text-align:left}td.c{text-align:center}.b{font-weight:bold}.grp{background:#f1f5f9}tr{page-break-inside:avoid}thead{display:table-header-group}.tot td{background:#f3f3f3}
.sign{display:flex;justify-content:space-around;margin-top:16px;text-align:center}.sign div{width:30%}</style></head><body>
<div style="font-weight:bold">TRƯỜNG TRUNG CẤP KINH TẾ - KỸ THUẬT PHAN CHU TRINH</div>
<h2>BẢNG LƯƠNG ĐÀO TẠO</h2><p class="sub">${esc(monthLabelOf(monthKey))}</p>
<table><thead><tr><th>STT</th>${pcols.map((c) => `<th>${esc(c.label)}</th>`).join("")}</tr></thead><tbody>${body}${foot}</tbody></table>
<div class="sign"><div><b>Người lập bảng</b><br><i>(Ký, ghi rõ họ tên)</i></div><div><b>Kế toán</b><br><i>(Ký, ghi rõ họ tên)</i></div><div><i>Ngày ...... tháng ...... năm ${esc(String(monthKey).slice(0, 4))}</i><br><b>Hiệu trưởng</b><br><i>(Ký, ghi rõ họ tên)</i></div></div>
<script>window.onload=function(){setTimeout(function(){window.print()},200)}</script></body></html>`;
    const w = window.open("", "_blank");
    if (!w) { window.alert("Trình duyệt chặn cửa sổ in — cho phép popup rồi bấm lại."); return; }
    w.document.open(); w.document.write(html); w.document.close();
  };
  let nhomTruoc = null;
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8, flexWrap: "wrap" }}>
        <p style={{ color: "#6b7280", fontSize: 13, margin: 0, flex: 1, minWidth: 260 }}>
          {data ? <>Nguồn: <b>{data.nguon}</b>{data.tieuDe ? ` (${data.tieuDe})` : ""} — nhập lúc {new Date(data.importedAt).toLocaleString("vi-VN")}. </> : "Chưa có dữ liệu tháng này. "}
          Bấm "📥 Nhập từ Excel" chọn file BẢNG LƯƠNG THÁNG ... (sheet "Lương _Đào tạo") để nạp / cập nhật.
        </p>
        <label style={{ padding: "6px 12px", border: "1px solid #0ea5a3", borderRadius: 6, background: "#ecfeff", color: "#0f766e", cursor: busy ? "wait" : "pointer", fontSize: 13, fontWeight: 600 }}>
          {busy ? "Đang nhập..." : "📥 Nhập từ Excel"}
          <input type="file" accept=".xlsx,.xls" onChange={nhapFile} disabled={busy} style={{ display: "none" }} />
        </label>
        <button type="button" onClick={printList} disabled={rows.length === 0} style={{ padding: "5px 12px", border: "1px solid #374151", borderRadius: 6, background: "#fff", color: "#374151", cursor: rows.length ? "pointer" : "not-allowed", fontSize: 13, fontWeight: 600 }}>🖨 In</button>
        <ExportBtn onClick={exportExcel} disabled={rows.length === 0} />
      </div>
      {rows.length > 0 && (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8 }}>
          <table style={{ borderCollapse: "collapse", fontSize: 13 }}>
            <thead><tr><th style={th}>STT</th>{cols.map((c) => (<th key={c.key} style={{ ...th, whiteSpace: "normal", minWidth: c.money ? 90 : c.key === "hoten" ? 170 : 60, background: c.nhom === "Phụ cấp" ? "#f0fdf4" : c.nhom === "Khoản phải trừ" ? "#fef2f2" : th.background }}>{c.label}</th>))}</tr></thead>
            <tbody>
              {rows.map((r, i) => {
                const header = r.nhom && r.nhom !== nhomTruoc;
                nhomTruoc = r.nhom;
                return (
                  <React.Fragment key={i}>
                    {header && (<tr><td colSpan={cols.length + 1} style={{ ...td, textAlign: "left", fontWeight: 700, background: "#f1f5f9" }}>{r.nhom}</td></tr>)}
                    <tr>
                      <td style={td}>{i + 1}</td>
                      {cols.map((c) => (
                        <td key={c.key} style={{ ...td, textAlign: c.key === "hoten" || c.key.startsWith("ghiChu") ? "left" : c.money ? "right" : "center", fontWeight: c.key === "hoten" || c.key === "thucLinh" || c.key === "tongThuNhap" ? 600 : 400, color: c.key === "thucLinh" ? "#047857" : undefined, whiteSpace: c.key.startsWith("ghiChu") ? "normal" : "nowrap", minWidth: c.key.startsWith("ghiChu") ? 180 : undefined }}>{cell(r, c)}</td>
                      ))}
                    </tr>
                  </React.Fragment>
                );
              })}
              <tr>
                <td style={{ ...td, background: "#ecfdf5", fontWeight: 700 }} />
                {cols.map((c) => (<td key={c.key} style={{ ...td, background: "#ecfdf5", fontWeight: 700, textAlign: c.money ? "right" : "left", color: c.key === "thucLinh" ? "#047857" : undefined }}>{c.key === "hoten" ? "Tổng cộng" : c.money ? vnd(tong[c.key]) : ""}</td>))}
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

// Tab "Tạm ứng lương" / "QTKD" — danh sách từ file Excel kế toán "BẢNG LƯƠNG THÁNG ..."
// (sheet "Danh sách ứng lương tháng ..." / "QTKD_T..."). Không lưu số tài khoản/ngân hàng.
const BANG_CK = {
  tamung: { kind: "tam-ung", ten: "Tạm ứng lương", file: "tam_ung_luong", sheetRe: /[uứ]ng\s*l[uư][oơ]ng/i, cols: TAM_UNG_COLS },
  qtkd: { kind: "qtkd", ten: "QTKD", file: "qtkd", sheetRe: /qtkd/i, cols: QTKD_COLS },
};
const BangChuyenKhoanTab = ({ cfg, schoolId, monthKey }) => {
  const [data, setData] = useState(undefined);
  const [busy, setBusy] = useState(false);
  const [reload, setReload] = useState(0);
  useEffect(() => {
    if (!schoolId) return;
    getBangLuong(schoolId, monthKey, cfg.kind).then((d) => setData(d.data || null)).catch(() => setData(null));
  }, [schoolId, monthKey, reload, cfg.kind]);
  const nhapFile = async (e) => {
    const f = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!f) return;
    setBusy(true);
    try {
      const wb = XLSX.read(await f.arrayBuffer());
      const ten = wb.SheetNames.find((x) => cfg.sheetRe.test(x.normalize("NFC")));
      if (!ten) throw new Error(`Không thấy sheet ${cfg.ten} trong file.`);
      const r = parseBangChuyenKhoan(XLSX.utils.sheet_to_json(wb.Sheets[ten], { header: 1, raw: true, defval: null }), cfg.cols);
      if (!r.rows.length) throw new Error("Không đọc được dòng nào.");
      if (data && !window.confirm(`Ghi đè ${cfg.ten} ${monthLabelOf(monthKey)} bằng ${r.rows.length} dòng từ "${f.name}" (sheet "${ten}")?`)) return;
      await saveBangLuong(schoolId, monthKey, cfg.kind, { ...r, nguon: f.name.normalize("NFC") });
      setReload((k) => k + 1);
    } catch (err) { window.alert(err.message || "Không nhập được file."); } finally { setBusy(false); }
  };
  if (data === undefined) return <p>Đang tải...</p>;
  const rows = (data && data.rows) || [];
  const cols = cfg.cols;
  const tong = {};
  cols.filter((c) => c.money).forEach((c) => { tong[c.key] = rows.reduce((a, r) => a + (Number(r[c.key]) || 0), 0); });
  const exportExcel = () => exportTableExcel({
    title: `${cfg.ten} — ${monthLabelOf(monthKey)}`, sheetName: cfg.ten, fileName: `${cfg.file}_${monthKey}.xlsx`,
    header: ["STT", ...cols.map((c) => c.label)],
    rows: rows.map((r, i) => [i + 1, ...cols.map((c) => (c.money ? (r[c.key] ?? "") : (r[c.key] || "")))]),
    moneyCols: cols.map((c, i) => (c.money ? i + 1 : -1)).filter((i) => i >= 0),
    totalRow: ["", ...cols.map((c) => (c.key === "hoten" ? "Tổng cộng" : c.money ? tong[c.key] : ""))],
  });
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8, flexWrap: "wrap" }}>
        <p style={{ color: "#6b7280", fontSize: 13, margin: 0, flex: 1, minWidth: 260 }}>
          {data ? <>Nguồn: <b>{data.nguon}</b>{data.tieuDe ? ` (${data.tieuDe})` : ""} — nhập lúc {new Date(data.importedAt).toLocaleString("vi-VN")}. </> : "Chưa có dữ liệu tháng này. "}
          Bấm "📥 Nhập từ Excel" chọn file BẢNG LƯƠNG THÁNG ... để nạp / cập nhật.
        </p>
        <label style={{ padding: "6px 12px", border: "1px solid #0ea5a3", borderRadius: 6, background: "#ecfeff", color: "#0f766e", cursor: busy ? "wait" : "pointer", fontSize: 13, fontWeight: 600 }}>
          {busy ? "Đang nhập..." : "📥 Nhập từ Excel"}
          <input type="file" accept=".xlsx,.xls" onChange={nhapFile} disabled={busy} style={{ display: "none" }} />
        </label>
        <ExportBtn onClick={exportExcel} disabled={rows.length === 0} />
      </div>
      {rows.length > 0 && (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8, maxWidth: 900 }}>
          <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%" }}>
            <thead><tr><th style={th}>STT</th>{cols.map((c) => (<th key={c.key} style={th}>{c.label}</th>))}</tr></thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i}>
                  <td style={td}>{i + 1}</td>
                  {cols.map((c) => (<td key={c.key} style={{ ...td, textAlign: c.money ? "right" : "left", fontWeight: c.key === "hoten" || c.money ? 600 : 400, color: c.money ? "#047857" : undefined }}>{c.money ? (r[c.key] ? vnd(r[c.key]) : "") : (r[c.key] || "")}</td>))}
                </tr>
              ))}
              <tr>
                <td style={{ ...td, background: "#ecfdf5" }} />
                {cols.map((c) => (<td key={c.key} style={{ ...td, background: "#ecfdf5", fontWeight: 700, textAlign: c.money ? "right" : "left", color: c.money ? "#047857" : undefined }}>{c.key === "hoten" ? "Tổng cộng" : c.money ? vnd(tong[c.key]) : ""}</td>))}
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

// Tab "Ăn trưa Đào tạo" — từ file "Chấm công Phòng đào tạo tháng ..." (mỗi sheet 1 tuần):
// đi làm TRỌN 1 ngày (ô = 1) được ANTRUA_DON_GIA tiền ăn trưa; nửa ngày / nghỉ không tính.
const AnTruaTab = ({ schoolId, monthKey }) => {
  const [data, setData] = useState(undefined);
  const [busy, setBusy] = useState(false);
  const [reload, setReload] = useState(0);
  useEffect(() => {
    if (!schoolId) return;
    getBangLuong(schoolId, monthKey, "an-trua").then((d) => setData(d.data || null)).catch(() => setData(null));
  }, [schoolId, monthKey, reload]);
  const nhapFile = async (e) => {
    const f = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!f) return;
    setBusy(true);
    try {
      const wb = XLSX.read(await f.arrayBuffer());
      const r = parseChamCongDaoTao(wb.SheetNames.map((x) => XLSX.utils.sheet_to_json(wb.Sheets[x], { header: 1, raw: true, defval: null })));
      if (!r.rows.length) throw new Error("Không đọc được dòng nào.");
      if (r.thang && r.thang !== monthKey && !window.confirm(`File ghi tháng ${r.thang.split("-").reverse().join("/")}, đang chọn ${monthLabelOf(monthKey)}. Vẫn lưu vào ${monthLabelOf(monthKey)}?`)) return;
      if (data && !window.confirm(`Ghi đè Ăn trưa Đào tạo ${monthLabelOf(monthKey)} bằng ${r.rows.length} người từ "${f.name}"?`)) return;
      await saveBangLuong(schoolId, monthKey, "an-trua", { rows: r.rows, tieuDe: `Chấm công Phòng đào tạo ${r.thang || ""}`, nguon: f.name.normalize("NFC") });
      setReload((k) => k + 1);
    } catch (err) { window.alert(err.message || "Không nhập được file."); } finally { setBusy(false); }
  };
  if (data === undefined) return <p>Đang tải...</p>;
  const rows = (data && data.rows) || [];
  const tongTien = rows.reduce((a, r) => a + (Number(r.tienAnTrua) || 0), 0);
  const tongCong = rows.reduce((a, r) => a + (Number(r.congNgay) || 0), 0);
  const exportExcel = () => exportTableExcel({
    title: `Tiền ăn trưa Phòng đào tạo — ${monthLabelOf(monthKey)}`, sheetName: "Ăn trưa", fileName: `an_trua_dao_tao_${monthKey}.xlsx`,
    header: ["STT", "Phòng ban", "Họ tên", "Công ngày", "Số ngày làm trọn", "Số ngày nửa buổi", "Đơn giá", "Tiền ăn trưa", "Ghi chú", "Chi tiết ngày không trọn"],
    rows: rows.map((r, i) => [i + 1, r.boPhan || "", r.hoten, r.congNgay, r.ngayTron, r.ngayNua, ANTRUA_DON_GIA, { formula: `E${3 + i}*G${3 + i}`, result: r.tienAnTrua }, r.ghiChu || "", r.chiTiet || ""]),
    moneyCols: [6, 7],
    totalRow: ["", "", "Tổng cộng", tongCong, "", "", "", { formula: `SUM(H3:H${2 + rows.length})`, result: tongTien }, "", ""],
  });
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8, flexWrap: "wrap" }}>
        <p style={{ color: "#6b7280", fontSize: 13, margin: 0, flex: 1, minWidth: 260 }}>
          Tiền ăn trưa = {vnd(ANTRUA_DON_GIA)} × số ngày đi làm TRỌN ngày (nửa ngày, nghỉ không tính).{" "}
          {data ? <>Nguồn: <b>{data.nguon}</b> — nhập lúc {new Date(data.importedAt).toLocaleString("vi-VN")}. </> : "Chưa có dữ liệu tháng này. "}
          Bấm "📥 Nhập từ Excel" chọn file "Chấm công Phòng đào tạo tháng ..." (mỗi sheet 1 tuần).
        </p>
        <label style={{ padding: "6px 12px", border: "1px solid #0ea5a3", borderRadius: 6, background: "#ecfeff", color: "#0f766e", cursor: busy ? "wait" : "pointer", fontSize: 13, fontWeight: 600 }}>
          {busy ? "Đang nhập..." : "📥 Nhập từ Excel"}
          <input type="file" accept=".xlsx,.xls" onChange={nhapFile} disabled={busy} style={{ display: "none" }} />
        </label>
        <ExportBtn onClick={exportExcel} disabled={rows.length === 0} />
      </div>
      {rows.length > 0 && (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8, maxWidth: 1000 }}>
          <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%" }}>
            <thead><tr>{["STT", "Phòng ban", "Họ tên", "Công ngày", "Ngày làm trọn", "Ngày nửa buổi", "Đơn giá", "Tiền ăn trưa", "Ngày không trọn (ngày:công)"].map((h) => (<th key={h} style={th}>{h}</th>))}</tr></thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i}>
                  <td style={td}>{i + 1}</td>
                  <td style={{ ...td, textAlign: "left" }}>{r.boPhan}</td>
                  <td style={{ ...td, textAlign: "left", fontWeight: 600 }}>{r.hoten}{r.ghiChu ? <span style={{ color: "#6b7280", fontWeight: 400 }}> ({r.ghiChu})</span> : null}</td>
                  <td style={td}>{r.congNgay}</td>
                  <td style={{ ...td, fontWeight: 600 }}>{r.ngayTron}</td>
                  <td style={td}>{r.ngayNua || ""}</td>
                  <td style={{ ...td, textAlign: "right" }}>{vnd(ANTRUA_DON_GIA)}</td>
                  <td style={{ ...td, textAlign: "right", fontWeight: 700, color: "#047857" }}>{vnd(r.tienAnTrua)}</td>
                  <td style={{ ...td, textAlign: "left", color: "#6b7280", whiteSpace: "normal", minWidth: 200 }}>{r.chiTiet}</td>
                </tr>
              ))}
              <tr>
                <td style={{ ...td, background: "#ecfdf5", fontWeight: 700, textAlign: "left" }} colSpan={3}>Tổng cộng</td>
                <td style={{ ...td, background: "#ecfdf5", fontWeight: 700 }}>{tongCong}</td>
                <td style={{ ...td, background: "#ecfdf5" }} colSpan={3} />
                <td style={{ ...td, background: "#ecfdf5", fontWeight: 700, textAlign: "right", color: "#047857" }}>{vnd(tongTien)}</td>
                <td style={{ ...td, background: "#ecfdf5" }} />
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

// Tab "Đào tạo + GV Nghề" — gộp nhân sự Đào tạo (tab Công Đào Tạo) + GV Nghề (dòng GV Nghề ở tab Thu nhập)
// vào 1 bảng lương chung, đủ các khoản; có In + Xuất Excel. Chỉ đọc, số liệu lấy thẳng từ 2 nguồn trên.
// Tab "Thu nhập GV Nghề" — gộp đủ cột của tab 🛠 Chấm công GV Nghề (cách ra Tổng chấm công) + tab 💵 Thu nhập (cộng/trừ ra Thực nhận).
const TN_NGHE_COLS = [
  { key: "tiet", label: "Tiết thường", count: true, g: "cc" },
  { key: "tietCN", label: "Tiết CN", count: true, g: "cc" },
  { key: "tong", label: "Tổng tiết", count: true, g: "cc" },
  { key: "vuot", label: `Tiết vượt (−68)`, count: true, g: "cc" },
  { key: "luongCoBan", label: "Lương cơ bản", g: "cc" },
  { key: "pcChuyenMon", label: "PC chuyên môn", g: "cc" },
  { key: "lhq", label: "Lương hiệu quả", g: "cc" },
  { key: "ltv", label: "Lương tiết vượt", g: "cc" },
  { key: "htdt", label: "HT ĐT GVCN", g: "cc" },
  { key: "htTinHoc", label: "HT Tin học", g: "cc" },
  { key: "pcDaoTao", label: "PC đào tạo", g: "cc" },
  { key: "xangXe", label: "Xăng xe", g: "cc" },
  { key: "pcAn", label: "PC Ăn", g: "cc" },
  { key: "tongChamCong", label: "Tổng chấm công", total: true, g: "cc" },
  { key: "phuCap", label: "Phụ cấp khác", g: "tn" },
  { key: "kiemXe", label: "Kiểm xe", g: "tn" },
  { key: "khaoSat", label: "Khảo sát", g: "tn" },
  { key: "thuNhapKhac", label: "Thu nhập khác", g: "tn", note: "thuNhapKhacNoiDung" },
  { key: "quaTang", label: "Quà 20-10(HS)", g: "tn" },
  { key: "quaTangNT", label: "Quà 20-10(NT)", g: "tn" },
  { key: "tongThuNhap", label: "Tổng thu nhập", total: true, g: "tn" },
  { key: "bhxh", label: "BHXH", minus: true, g: "tn" },
  { key: "phiCongDoan", label: "Công đoàn", minus: true, g: "tn" },
  { key: "thue", label: "Thuế TNCN", minus: true, g: "tn" },
  { key: "tongTru", label: "Trừ vi phạm", minus: true, g: "tn" },
  { key: "khoanTruKhac", label: "Khoản trừ khác", minus: true, g: "tn", note: "khoanTruKhacNoiDung" },
  { key: "tamUng", label: "Tạm ứng", minus: true, g: "tn" },
  { key: "phiCK", label: "Phí CK", minus: true, g: "tn" },
  { key: "thucNhan", label: "Thực nhận", total: true, g: "tn" },
];
const ThuNhapNgheTab = ({ schoolId, monthKey }) => {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!schoolId) return;
    setRows(null); setErr("");
    Promise.all([getChamCongThangThuNhap(schoolId, monthKey), getChamCongNghe(schoolId, monthKey).catch(() => ({ rows: [] }))])
      .then(([tn, nghe]) => {
        const fk = (x) => String(x || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/gi, "d").toLowerCase().replace(/\s+/g, " ").trim();
        const N = (v) => Number(v) || 0;
        const ngheBy = {}; ((nghe && nghe.rows) || []).forEach((x) => { ngheBy[fk(x.hoten)] = x; });
        const PC = ["hotroTinHoc", "phuCapChuyenMon", "phuCapChucVu", "phuCapDienThoai", "phuCapXangXe", "phuCapAn", "phuCapKhac", "luongCaDem"];
        const list = ((tn && tn.rows) || []).filter((r) => String(r.loai || "").normalize("NFC") === "GV Nghề").map((r) => {
          const d = ngheBy[fk(r.hoten)] || {};
          const o = {
            hoten: r.hoten, fullTime: !!d.fullTime, treoLuong: !!r.treoLuong, bankName: r.bankName || "",
            tiet: N(d.tiet), tietCN: N(d.tietCN), tong: N(d.tong), vuot: N(d.vuot), luongCoBan: N(d.luongCoBan), pcChuyenMon: N(d.pcChuyenMon), lhq: N(d.lhq), ltv: N(d.ltv),
            htdt: N(d.htdt), htTinHoc: N(d.htTinHoc), pcDaoTao: N(d.pcDaoTao), xangXe: N(d.xangXe), pcAn: N(d.pcAn),
            tongChamCong: N(r.tongChamCong), phuCap: PC.reduce((a, k) => a + N(r[k]), 0), kiemXe: N(r.kiemXe), khaoSat: N(r.khaoSat), thuNhapKhac: N(r.thuNhapKhac), quaTang: N(r.quaTang), quaTangNT: N(r.quaTangNT),
            bhxh: N(r.bhxh), phiCongDoan: N(r.phiCongDoan), thue: Math.round(N(r.thueTNCN) + N(r.thueTNCNTru)), tongTru: N(r.tongTru), khoanTruKhac: N(r.khoanTruKhac), tamUng: N(r.tamUng), phiCK: N(r.phiCK),
            thucNhan: Math.round(N(r.thucNhan)), thuNhapKhacNoiDung: r.thuNhapKhacNoiDung || "", khoanTruKhacNoiDung: r.khoanTruKhacNoiDung || "",
          };
          o.tongThuNhap = o.tongChamCong + o.phuCap + o.kiemXe + o.khaoSat + o.thuNhapKhac + o.quaTang + o.quaTangNT;
          return o;
        }).sort((a, b) => a.hoten.localeCompare(b.hoten, "vi"));
        setRows(list);
      })
      .catch((e) => setErr(e.message || "Không tải được."));
  }, [schoolId, monthKey]);
  if (err) return <p style={{ color: "#dc2626" }}>{err}</p>;
  if (!rows) return <p>Đang tải...</p>;
  const cols = TN_NGHE_COLS;
  const tong = {}; cols.forEach((c) => { tong[c.key] = rows.filter((r) => !(c.key === "thucNhan" && r.treoLuong)).reduce((a, r) => a + (r[c.key] || 0), 0); });
  const ccN = cols.filter((c) => c.g === "cc").length, tnN = cols.length - ccN;
  const exportExcel = () => exportTableExcel({
    title: `Thu nhập GV Nghề — ${monthLabelOf(monthKey)}`, sheetName: "Thu nhập GV Nghề", fileName: `thu_nhap_gv_nghe_${monthKey}.xlsx`,
    header: ["STT", "Họ và tên", ...cols.map((c) => c.label), "Ngân hàng", "Ghi chú"],
    rows: rows.map((r, i) => [i + 1, r.hoten + (r.fullTime ? " (FullTime)" : ""), ...cols.map((c) => r[c.key] || 0), r.bankName, [r.treoLuong ? "Treo lương" : "", r.thuNhapKhacNoiDung && `+ ${r.thuNhapKhacNoiDung}`, r.khoanTruKhacNoiDung && `− ${r.khoanTruKhacNoiDung}`].filter(Boolean).join("; ")]),
    moneyCols: cols.map((c, i) => (c.count ? -1 : 2 + i)).filter((i) => i >= 0),
    totalRow: ["", "Tổng cộng", ...cols.map((c) => tong[c.key]), "", ""],
  });
  const printList = () => {
    const esc = (x) => String(x ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const m = (v) => (v ? Math.round(v).toLocaleString("vi-VN") : "");
    const pc = cols.filter((c) => c.total || rows.some((r) => r[c.key])); // bỏ cột toàn 0 cho vừa khổ giấy
    const pcc = pc.filter((c) => c.g === "cc").length, ptn = pc.length - pcc;
    const body = rows.map((r, i) => `<tr><td class="c">${i + 1}</td><td class="l b">${esc(r.hoten)}${r.fullTime ? " <i>(FT)</i>" : ""}${r.treoLuong ? " <i>(treo)</i>" : ""}</td>${pc.map((c) => `<td class="${c.total ? "b" : ""}${c.count ? " c" : ""}">${c.count ? (r[c.key] || "") : m(r[c.key])}</td>`).join("")}</tr>`).join("");
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>Thu nhập GV Nghề ${esc(monthLabelOf(monthKey))}</title>
<style>@page{size:A4 landscape;margin:6mm}body{font-family:"Times New Roman",serif;font-size:9.5px;color:#000}h2{text-align:center;margin:2px 0}.sub{text-align:center;margin:0 0 5px}
table{border-collapse:collapse;width:100%}th,td{border:1px solid #000;padding:2px 3px;text-align:right}th{background:#eee;text-align:center;font-size:9px}
td.l{text-align:left}td.c{text-align:center}.b{font-weight:bold}tr{page-break-inside:avoid}thead{display:table-header-group}.tot td{background:#f3f3f3;font-weight:bold}.g th{background:#ddd;font-size:10px}
.sign{display:flex;justify-content:space-around;margin-top:14px;text-align:center}.sign div{width:30%}</style></head><body>
<div style="font-weight:bold">TRƯỜNG TRUNG CẤP KINH TẾ - KỸ THUẬT PHAN CHU TRINH</div>
<h2>BẢNG THU NHẬP GIÁO VIÊN NGHỀ</h2><p class="sub">${esc(monthLabelOf(monthKey))}</p>
<table><thead><tr class="g"><th rowspan="2">STT</th><th rowspan="2">Họ và tên</th><th colspan="${pcc}">CHẤM CÔNG</th><th colspan="${ptn}">THU NHẬP</th></tr>
<tr>${pc.map((c) => `<th>${esc(c.label)}</th>`).join("")}</tr></thead>
<tbody>${body}<tr class="tot"><td></td><td class="l">Tổng cộng (${rows.length} người)</td>${pc.map((c) => `<td class="${c.count ? "c" : ""}">${c.count ? tong[c.key] : m(tong[c.key])}</td>`).join("")}</tr></tbody></table>
<div class="sign"><div><b>Người lập bảng</b><br><i>(Ký, ghi rõ họ tên)</i></div><div><b>Kế toán</b><br><i>(Ký, ghi rõ họ tên)</i></div><div><i>Ngày ...... tháng ...... năm ${esc(String(monthKey).slice(0, 4))}</i><br><b>Hiệu trưởng</b><br><i>(Ký, ghi rõ họ tên)</i></div></div>
<script>window.onload=function(){setTimeout(function(){window.print()},200)}</script></body></html>`;
    const w = window.open("", "_blank");
    if (!w) { window.alert("Trình duyệt chặn cửa sổ in — cho phép popup rồi bấm lại."); return; }
    w.document.open(); w.document.write(html); w.document.close();
  };
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8, flexWrap: "wrap" }}>
        <p style={{ color: "#6b7280", fontSize: 13, margin: 0, flex: 1, minWidth: 260 }}>
          Gộp tab 🛠 Chấm công GV Nghề (cách ra Tổng chấm công) và tab 💵 Thu nhập (cộng/trừ ra Thực nhận) — chỉ xem, sửa số ở tab gốc. Người treo lương không tính vào tổng Thực nhận. Bản in tự bỏ cột toàn số 0 cho vừa khổ A4 ngang.
        </p>
        <button type="button" onClick={printList} disabled={rows.length === 0} style={{ padding: "5px 12px", border: "1px solid #374151", borderRadius: 6, background: "#fff", color: "#374151", cursor: rows.length ? "pointer" : "not-allowed", fontSize: 13, fontWeight: 600 }}>🖨 In</button>
        <ExportBtn onClick={exportExcel} disabled={rows.length === 0} />
      </div>
      {rows.length === 0 ? <p style={{ color: "#6b7280" }}>Chưa có dữ liệu GV Nghề tháng này.</p> : (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8 }}>
          <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%" }}>
            <thead>
              <tr><th style={th} rowSpan={2}>STT</th><th style={{ ...th, textAlign: "left" }} rowSpan={2}>Họ và tên</th><th style={{ ...th, background: "#e0f2fe" }} colSpan={ccN}>🛠 CHẤM CÔNG</th><th style={{ ...th, background: "#fef3c7" }} colSpan={tnN}>💵 THU NHẬP</th></tr>
              <tr>{cols.map((c) => (<th key={c.key} style={{ ...th, whiteSpace: "normal", background: c.minus ? "#fef2f2" : c.total ? "#ecfdf5" : th.background }}>{c.label}</th>))}</tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.hoten} style={r.treoLuong ? { background: "#fff7ed" } : undefined}>
                  <td style={td}>{i + 1}</td>
                  <td style={{ ...td, textAlign: "left", fontWeight: 600, whiteSpace: "nowrap" }}>{r.hoten}{r.fullTime ? <span style={{ color: "#6b7280", fontWeight: 400 }}> (FullTime)</span> : null}{r.treoLuong ? <span style={{ color: "#c2410c", fontWeight: 400 }}> (treo lương)</span> : null}</td>
                  {cols.map((c) => (<td key={c.key} title={c.note ? r[c.note] : undefined} style={{ ...td, textAlign: c.count ? "center" : "right", fontWeight: c.total ? 700 : 400, color: c.key === "thucNhan" ? "#047857" : c.minus && r[c.key] ? "#dc2626" : undefined }}>{c.count ? (r[c.key] || "") : r[c.key] ? vnd(r[c.key]) : ""}</td>))}
                </tr>
              ))}
              <tr>
                <td style={{ ...td, background: "#ecfdf5" }} />
                <td style={{ ...td, background: "#ecfdf5", fontWeight: 700, textAlign: "left" }}>Tổng cộng ({rows.length} người)</td>
                {cols.map((c) => (<td key={c.key} style={{ ...td, background: "#ecfdf5", fontWeight: 700, textAlign: c.count ? "center" : "right", color: c.key === "thucNhan" ? "#047857" : undefined }}>{c.count ? tong[c.key] : vnd(tong[c.key])}</td>))}
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const DT_NGHE_COLS = [
  // Chi tiết cách ra cột "Lương" của GV Nghề (Đào tạo để trống)
  { key: "dCongTT", label: "Công thỏa thuận", count: true },
  { key: "dCongTe", label: "Công thực tế", count: true },
  { key: "nTiet", label: "Số tiết", count: true },
  { key: "nTietCN", label: "Tiết CN", count: true },
  { key: "nTong", label: "Tổng tiết", count: true },
  { key: "nVuot", label: "Tiết vượt (−68)", count: true },
  { key: "nLuongCB", label: "Lương cơ bản" },
  { key: "nLhq", label: "Lương hiệu quả" },
  { key: "nLtv", label: "Lương tiết vượt" },
  { key: "nHtdt", label: "HT ĐT GVCN" },
  { key: "nTinHoc", label: "HT Tin học" },
  { key: "nPcDT", label: "PC đào tạo" },
  { key: "dDungLop", label: "PC Đứng lớp" },
  { key: "dChuyenMon", label: "PC Chuyên môn" },
  { key: "dDienThoai", label: "PC Điện thoại" },
  { key: "dChucVu", label: "PC Chức vụ/GVCN" },
  { key: "nXang", label: "Xăng xe" },
  { key: "nAn", label: "PC Ăn" },
  { key: "dKhac", label: "PC Khác" },
  { key: "luong", label: "Lương (Đào tạo: theo ngày công; Nghề: tổng các cột trên)" },
  { key: "phuCap", label: "Tổng phụ cấp (= cộng các cột PC)" },
  { key: "kiemXe", label: "Kiểm xe" },
  { key: "khaoSat", label: "Khảo sát" },
  { key: "thuNhapKhac", label: "Thu nhập khác" },
  { key: "quaHS", label: "Quà 20-10(HS)" },
  { key: "quaNT", label: "Quà 20-10(NT)" },
  { key: "tongThuNhap", label: "Tổng thu nhập", total: true },
  { key: "bhxh", label: "BHXH", minus: true },
  { key: "congDoan", label: "Công đoàn", minus: true },
  { key: "thue", label: "Thuế TNCN", minus: true },
  { key: "truKhac", label: "Khác / Phạt / Vi phạm", minus: true },
  { key: "tamUng", label: "Tạm ứng", minus: true },
  { key: "phiNH", label: "Phí ngân hàng", minus: true },
  { key: "thucNhan", label: "Thực nhận", total: true },
  { key: "soTienCK", label: "Số tiền CK" },
  { key: "hoanVe", label: "Hoàn về" },
  { key: "ghiChu", label: "Ghi chú", text: true },
  { key: "ghiChuPhuCap", label: "Ghi chú phụ cấp", text: true },
];
const DaoTaoNgheTab = ({ schoolId, monthKey }) => {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (!schoolId) return;
    setRows(null); setErr("");
    Promise.all([getCongDaoTao(schoolId, monthKey).catch(() => ({})), getChamCongThangThuNhap(schoolId, monthKey), getChamCongNghe(schoolId, monthKey).catch(() => ({ rows: [] }))])
      .then(([cdt, tn, nghe]) => {
        const fk = (x) => String(x || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/đ/gi, "d").toLowerCase().replace(/\s+/g, " ").trim();
        const ngheBy = {}; ((nghe && nghe.rows) || []).forEach((x) => { ngheBy[fk(x.hoten)] = x; });
        const N = (v) => Number(v) || 0;
        // Phần tăng lương ghi ở "Ghi chú phụ cấp" (vd "Tăng lương 2.000.000đ từ T9/2026") → tách sang cột Lương hiệu quả, Lương cơ bản giữ mức cũ.
        const tangLuong = (r) => { const m = String(r.ghiChuPhuCap || "").match(/tăng lương\s*([\d.,]+)/i); return m ? Number(m[1].replace(/[.,]/g, "")) || 0 : 0; };
        const dt0 = (((cdt || {}).data || {}).rows || []).map((r) => ({
          nhom: r.nhom ? `Đào tạo — ${r.nhom.replace(/^[IVX]+\.\s*/, "")}` : "Đào tạo", hoten: r.hoten, chucVu: r.chucVu || "", truong: r.truong || "",
          dCongTT: N(r.congThoaThuan), dCongTe: N(r.congThucTe), nLuongCB: N(r.luongCoBan) - tangLuong(r), nLhq: tangLuong(r),
          dDungLop: N(r.pcDungLop), dChuyenMon: N(r.pcChuyenMon), dDienThoai: N(r.pcDienThoai), dChucVu: N(r.pcChucVu), nXang: N(r.pcXangXe), nAn: N(r.pcAn), dKhac: N(r.pcKhac),
          luong: N(r.luongNgayCong), phuCap: N(r.pcDungLop) + N(r.pcChuyenMon) + N(r.pcDienThoai) + N(r.pcChucVu) + N(r.pcXangXe) + N(r.pcAn) + N(r.pcKhac), kiemXe: 0, khaoSat: 0, thuNhapKhac: 0, quaHS: N(r.quaTang), quaNT: N(r.quaTangNT),
          tongThuNhap: N(r.tongThuNhap), bhxh: N(r.bhxh), congDoan: N(r.congDoan), thue: N(r.thueTNCN), truKhac: N(r.truKhac), tamUng: N(r.tamUng), phiNH: N(r.phiNganHang), thucNhan: N(r.thucLinh),
          soTienCK: N(r.soTienCK), hoanVe: N(r.soTienCK) > 0 ? Math.round(N(r.soTienCK) - N(r.thucLinh)) : 0, ghiChu: r.ghiChu || "", ghiChuPhuCap: r.ghiChuPhuCap || "",
        }));
        const dt = dt0.map((x) => ({ ...x, laDaoTao: true }));
        const PC = ["hotroTinHoc", "phuCapChuyenMon", "phuCapChucVu", "phuCapDienThoai", "phuCapXangXe", "phuCapAn", "phuCapKhac", "luongCaDem"];
        const ng = ((tn && tn.rows) || []).filter((r) => String(r.loai || "").normalize("NFC") === "GV Nghề").map((r) => {
          const o = {
            ...((d) => (d ? { nTiet: N(d.tiet), nTietCN: N(d.tietCN), nTong: N(d.tong), nVuot: N(d.vuot), nLuongCB: N(d.luongCoBan), nLhq: N(d.lhq), nLtv: N(d.ltv), nHtdt: N(d.htdt), nTinHoc: N(d.htTinHoc), nPcDT: N(d.pcDaoTao), nXang: N(d.xangXe), nAn: N(d.pcAn), dChuyenMon: N(d.pcChuyenMon) } : {}))(ngheBy[fk(r.hoten)]),
            nhom: "GV Nghề", hoten: r.hoten, chucVu: r.treoLuong ? "Treo lương" : (ngheBy[fk(r.hoten)] || {}).fullTime ? "FullTime" : "",
            luong: N(r.tongChamCong), phuCap: PC.reduce((a, k) => a + N(r[k]), 0), kiemXe: N(r.kiemXe), khaoSat: N(r.khaoSat), thuNhapKhac: N(r.thuNhapKhac), quaHS: N(r.quaTang), quaNT: N(r.quaTangNT),
            bhxh: N(r.bhxh), congDoan: N(r.phiCongDoan), thue: N(r.thueTNCN) + N(r.thueTNCNTru), truKhac: N(r.tongTru) + N(r.khoanTruKhac), tamUng: N(r.tamUng), phiNH: N(r.phiCK), thucNhan: Math.round(N(r.thucNhan)),
          };
          o.tongThuNhap = o.luong + o.phuCap + o.kiemXe + o.khaoSat + o.thuNhapKhac + o.quaHS + o.quaNT;
          return o;
        });
        setRows([...dt, ...ng]);
      })
      .catch((e) => setErr(e.message || "Không tải được."));
  }, [schoolId, monthKey]);
  if (err) return <p style={{ color: "#dc2626" }}>{err}</p>;
  if (!rows) return <p>Đang tải...</p>;
  const cols = DT_NGHE_COLS.filter((c) => c.total || rows.some((r) => r[c.key]));
  const tong = {}; cols.forEach((c) => { tong[c.key] = c.text ? "" : rows.reduce((a, r) => a + (r[c.key] || 0), 0); });
  const exportExcel = () => {
    // Xuất đủ tất cả cột; ô tính được thì ghi công thức Excel (chỉ khi công thức ra đúng số đang có, lệch thì ghi số).
    const xc = DT_NGHE_COLS; const FIX = 5; const R0 = 3;
    const colL = (n) => { let x = ""; n += 1; while (n > 0) { const m = (n - 1) % 26; x = String.fromCharCode(65 + m) + x; n = Math.floor((n - 1) / 26); } return x; };
    const L = {}; xc.forEach((c, i) => { L[c.key] = colL(FIX + i); });
    const sum = (r, ks) => ks.reduce((a, k) => a + (Number(r[k]) || 0), 0);
    const PC_DT = ["dDungLop", "dChuyenMon", "dDienThoai", "dChucVu", "nXang", "nAn", "dKhac"];
    const LUONG_NGHE = ["nLuongCB", "nLhq", "nLtv", "nHtdt", "nTinHoc", "nPcDT", "dChuyenMon", "nXang", "nAn"];
    const TONG = ["luong", "phuCap", "kiemXe", "khaoSat", "thuNhapKhac", "quaHS", "quaNT"];
    const TRU = ["bhxh", "congDoan", "thue", "truKhac", "tamUng", "phiNH"];
    const fx = (row, ks, sign) => ks.map((k, j) => `${j === 0 ? "" : sign || "+"}${L[k]}${row}`).join("");
    const formulaOf = (r, key, row) => {
      const v = Number(r[key]) || 0; const ok = (calc) => Math.abs(calc - v) <= 1;
      if (key === "luong" && r.laDaoTao && v && ok(sum(r, ["nLuongCB", "nLhq"]))) return fx(row, ["nLuongCB", "nLhq"]);
      if (key === "luong" && !r.laDaoTao && v && ok(sum(r, LUONG_NGHE))) return fx(row, LUONG_NGHE);
      if (key === "phuCap" && r.laDaoTao && ok(sum(r, PC_DT))) return fx(row, PC_DT);
      if (key === "tongThuNhap" && ok(sum(r, TONG))) return fx(row, TONG);
      if (key === "thucNhan" && ok(sum(r, ["tongThuNhap"]) - sum(r, TRU))) return `${L.tongThuNhap}${row}-${fx(row, TRU, "-")}`;
      if (key === "hoanVe" && r.soTienCK > 0 && ok(r.soTienCK - r.thucNhan)) return `${L.soTienCK}${row}-${L.thucNhan}${row}`;
      return null;
    };
    const xr = rows.map((r, i) => {
      const row = R0 + i;
      return [i + 1, r.hoten, r.chucVu, r.truong || "", r.nhom, ...xc.map((c) => {
        if (c.text) return r[c.key] || "";
        const v = Number(r[c.key]) || 0; const f = formulaOf(r, c.key, row);
        return f ? { formula: f, result: v } : v;
      })];
    });
    const last = R0 + rows.length - 1;
    exportTableExcel({
      title: `Bảng lương Đào tạo + GV Nghề — ${monthLabelOf(monthKey)}`, sheetName: "Đào tạo + Nghề", fileName: `luong_daotao_nghe_${monthKey}.xlsx`,
      header: ["STT", "Họ và tên", "Chức vụ", "Trường", "Bộ phận", ...xc.map((c) => c.label)],
      rows: xr,
      moneyCols: xc.map((c, i) => (c.count || c.text ? -1 : FIX + i)).filter((i) => i >= 0),
      totalRow: ["", "Tổng cộng", "", "", "", ...xc.map((c) => (c.text ? "" : { formula: `SUM(${L[c.key]}${R0}:${L[c.key]}${last})`, result: rows.reduce((a, r) => a + (Number(r[c.key]) || 0), 0) }))],
    });
  };
  const printList = () => {
    const esc = (x) => String(x ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const money = (v) => (v ? Math.round(v).toLocaleString("vi-VN") : "");
    let nt = null; let stt = 0;
    const body = rows.map((r) => {
      const h = r.nhom !== nt ? `<tr><td colspan="${cols.length + 4}" class="l b grp">${esc(r.nhom)}</td></tr>` : "";
      nt = r.nhom; stt += 1;
      return h + `<tr><td class="c">${stt}</td><td class="l b">${esc(r.hoten)}</td><td class="l">${esc(r.chucVu)}</td><td class="l">${esc(r.truong)}</td>${cols.map((c) => `<td class="${c.total ? "b" : ""}${c.text ? " l" : ""}">${c.text ? esc(r[c.key]) : money(r[c.key])}</td>`).join("")}</tr>`;
    }).join("");
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>Lương Đào tạo + GV Nghề ${esc(monthLabelOf(monthKey))}</title>
<style>@page{size:A4 landscape;margin:8mm}body{font-family:"Times New Roman",serif;font-size:10.5px;color:#000}h2{text-align:center;margin:2px 0}.sub{text-align:center;margin:0 0 6px}
table{border-collapse:collapse;width:100%}th,td{border:1px solid #000;padding:2px 4px;text-align:right}th{background:#eee;text-align:center;font-size:10px}
td.l{text-align:left}td.c{text-align:center}.b{font-weight:bold}.grp{background:#f1f5f9}tr{page-break-inside:avoid}thead{display:table-header-group}.tot td{background:#f3f3f3;font-weight:bold}
.sign{display:flex;justify-content:space-around;margin-top:16px;text-align:center}.sign div{width:30%}</style></head><body>
<div style="font-weight:bold">TRƯỜNG TRUNG CẤP KINH TẾ - KỸ THUẬT PHAN CHU TRINH</div>
<h2>BẢNG LƯƠNG ĐÀO TẠO VÀ GIÁO VIÊN NGHỀ</h2><p class="sub">${esc(monthLabelOf(monthKey))}</p>
<table><thead><tr><th>STT</th><th>Họ và tên</th><th>Chức vụ</th><th>Trường</th>${cols.map((c) => `<th>${esc(c.label)}</th>`).join("")}</tr></thead>
<tbody>${body}<tr class="tot"><td></td><td class="l">Tổng cộng (${rows.length} người)</td><td></td><td></td>${cols.map((c) => `<td>${c.text ? "" : money(tong[c.key])}</td>`).join("")}</tr></tbody></table>
<div class="sign"><div><b>Người lập bảng</b><br><i>(Ký, ghi rõ họ tên)</i></div><div><b>Kế toán</b><br><i>(Ký, ghi rõ họ tên)</i></div><div><i>Ngày ...... tháng ...... năm ${esc(String(monthKey).slice(0, 4))}</i><br><b>Hiệu trưởng</b><br><i>(Ký, ghi rõ họ tên)</i></div></div>
<script>window.onload=function(){setTimeout(function(){window.print()},200)}</script></body></html>`;
    const w = window.open("", "_blank");
    if (!w) { window.alert("Trình duyệt chặn cửa sổ in — cho phép popup rồi bấm lại."); return; }
    w.document.open(); w.document.write(html); w.document.close();
  };
  let nhomTruoc = null;
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8, flexWrap: "wrap" }}>
        <p style={{ color: "#6b7280", fontSize: 13, margin: 0, flex: 1, minWidth: 260 }}>
          Gộp nhân sự Đào tạo (tab 🏫 Công Đào Tạo) và GV Nghề (tab 💵 Thu nhập) — chỉ xem, sửa số ở tab gốc. Lương: Đào tạo = Lương theo ngày công; GV Nghề = Tổng nhận ở tab 🛠 Chấm công GV Nghề (đã gồm xăng xe, PC ăn, HT tin học...).
        </p>
        <button type="button" onClick={printList} disabled={rows.length === 0} style={{ padding: "5px 12px", border: "1px solid #374151", borderRadius: 6, background: "#fff", color: "#374151", cursor: rows.length ? "pointer" : "not-allowed", fontSize: 13, fontWeight: 600 }}>🖨 In</button>
        <ExportBtn onClick={exportExcel} disabled={rows.length === 0} />
      </div>
      {rows.length === 0 ? <p style={{ color: "#6b7280" }}>Chưa có dữ liệu tháng này.</p> : (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8 }}>
          <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%" }}>
            <thead><tr><th style={th}>STT</th><th style={{ ...th, textAlign: "left" }}>Họ và tên</th><th style={{ ...th, textAlign: "left" }}>Chức vụ</th><th style={{ ...th, textAlign: "left" }}>Trường</th>{cols.map((c) => (<th key={c.key} style={{ ...th, whiteSpace: "normal", background: c.minus ? "#fef2f2" : c.total ? "#ecfdf5" : th.background }}>{c.label}</th>))}</tr></thead>
            <tbody>
              {rows.map((r, i) => {
                const header = r.nhom !== nhomTruoc; nhomTruoc = r.nhom;
                return (
                  <React.Fragment key={i}>
                    {header && (<tr><td colSpan={cols.length + 4} style={{ ...td, textAlign: "left", fontWeight: 700, background: "#f1f5f9" }}>{r.nhom}</td></tr>)}
                    <tr>
                      <td style={td}>{i + 1}</td>
                      <td style={{ ...td, textAlign: "left", fontWeight: 600, whiteSpace: "nowrap" }}>{r.hoten}</td>
                      <td style={{ ...td, textAlign: "left", whiteSpace: "nowrap", color: "#374151" }}>{r.chucVu}</td>
                      <td style={{ ...td, textAlign: "left", whiteSpace: "nowrap", color: "#374151" }}>{r.truong}</td>
                      {cols.map((c) => (c.text ? <td key={c.key} style={{ ...td, textAlign: "left", whiteSpace: "normal", minWidth: 160, color: "#374151" }}>{r[c.key]}</td> : <td key={c.key} style={{ ...td, textAlign: "right", fontWeight: c.total ? 700 : 400, color: c.key === "thucNhan" ? "#047857" : c.minus && r[c.key] ? "#dc2626" : undefined }}>{r[c.key] ? vnd(r[c.key]) : ""}</td>))}
                    </tr>
                  </React.Fragment>
                );
              })}
              <tr>
                <td style={{ ...td, background: "#ecfdf5" }} />
                <td style={{ ...td, background: "#ecfdf5", fontWeight: 700, textAlign: "left" }}>Tổng cộng ({rows.length} người)</td>
                <td style={{ ...td, background: "#ecfdf5" }} /><td style={{ ...td, background: "#ecfdf5" }} />
                {cols.map((c) => (<td key={c.key} style={{ ...td, background: "#ecfdf5", fontWeight: 700, textAlign: "right", color: c.key === "thucNhan" ? "#047857" : undefined }}>{c.text ? "" : vnd(tong[c.key])}</td>))}
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const KiemXeTab = ({ schoolId, monthKey }) => {
  const [info, setInfo] = useState(null);
  const [reload, setReload] = useState(0);
  useEffect(() => {
    if (!schoolId) return;
    getPcKiemXe(schoolId, monthKey).then((d) => setInfo({ ngayCong: d.ngayCongThang || 0, ov: d.overrides || {}, ds: d.ds || [] })).catch(() => setInfo({ ngayCong: 0, ov: {}, ds: [] }));
  }, [schoolId, monthKey, reload]);
  if (!info) return <p>Đang tải...</p>;
  const { ngayCong, ov, ds } = info;
  // Danh sách = danh sách kiểm xe trong database + mọi người đã có số ngày kiểm xe lưu trong tháng.
  const dsThang = [...ds];
  Object.values(ov).forEach((o) => { const n = o && String(o.hoten || "").trim(); if (n && !dsThang.some((x) => foldPc(x) === foldPc(n))) dsThang.push(n); });
  const list = dsThang.map((hoten) => {
    const o = ov[foldPc(hoten)];
    const soNgay = o && Number.isFinite(Number(o.soNgay)) ? Number(o.soNgay) : 0;
    return { hoten, soNgay, tien: tienPcKiemXe(soNgay, ngayCong), daSua: !!o, trongDs: ds.some((x) => foldPc(x) === foldPc(hoten)) };
  });
  const tong = list.reduce((a, r) => a + r.tien, 0);
  const sua = async (r) => { if (await nhapSoNgayKiemXe(schoolId, monthKey, r.hoten, r.soNgay, ngayCong)) setReload((k) => k + 1); };
  const themNguoi = async () => {
    const ten = window.prompt("Họ tên người được giao kiểm xe (đúng như hồ sơ):", "");
    if (!ten || !ten.trim()) return;
    try { await savePcKiemXeDs(schoolId, ten.trim(), "add"); setReload((k) => k + 1); } catch (e) { window.alert(e.message || "Không lưu được."); }
  };
  const boNguoi = async (r) => {
    if (!window.confirm(`Bỏ ${r.hoten} khỏi danh sách kiểm xe? (Số ngày đã lưu của các tháng vẫn giữ.)`)) return;
    try { await savePcKiemXeDs(schoolId, r.hoten, "remove"); setReload((k) => k + 1); } catch (e) { window.alert(e.message || "Không lưu được."); }
  };
  const exportExcel = () => exportTableExcel({
    title: `Chấm công kiểm xe — ${monthLabelOf(monthKey)}`, sheetName: "Kiểm xe", fileName: `cham_cong_kiem_xe_${monthKey}.xlsx`,
    header: ["STT", "Họ và tên", "Số ngày kiểm xe", "Số ngày tháng (trừ Chủ nhật)", "Đơn giá", "PC kiểm xe"],
    rows: list.map((r, i) => [i + 1, r.hoten, r.soNgay, ngayCong, PC_KIEM_XE_DON_GIA, { formula: `ROUND(E${3 + i}*C${3 + i}/D${3 + i},0)`, result: r.tien }]),
    moneyCols: [4, 5],
    totalRow: ["", "Tổng cộng", "", "", "", { formula: `SUM(F3:F${2 + list.length})`, result: tong }],
  });
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
        <p style={{ color: "#6b7280", fontSize: 13, margin: 0, flex: 1 }}>
          Phụ cấp kiểm xe = {vnd(PC_KIEM_XE_DON_GIA)} × Số ngày kiểm xe / {ngayCong} (số ngày của {monthLabelOf(monthKey)} trừ Chủ nhật). Bấm vào ô "Số ngày kiểm xe" để sửa; để trống = 0 ngày. Danh sách người kiểm xe lưu trong hệ thống (dùng chung mọi tháng) — "➕ Thêm người" / "✕" để thêm/bỏ.
        </p>
        <button type="button" onClick={themNguoi} style={{ padding: "4px 10px", border: "1px solid #0ea5a3", borderRadius: 6, background: "#ecfeff", color: "#0f766e", cursor: "pointer", fontSize: 12, fontWeight: 600 }}>➕ Thêm người</button>
        <ExportBtn onClick={exportExcel} disabled={list.length === 0} />
      </div>
      <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8, maxWidth: 720 }}>
        <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%" }}>
          <thead><tr>{["STT", "Họ và tên", "Số ngày kiểm xe", "Số ngày tháng (trừ CN)", "Đơn giá", "PC kiểm xe", ""].map((h) => (<th key={h || "x"} style={{ ...th, textAlign: h === "Họ và tên" ? "left" : "center" }}>{h}</th>))}</tr></thead>
          <tbody>
            {list.map((r, i) => (
              <tr key={r.hoten}>
                <td style={td}>{i + 1}</td>
                <td style={{ ...td, textAlign: "left", fontWeight: 600 }}>{r.hoten}</td>
                <td style={{ ...td, cursor: "pointer", textDecoration: "underline dotted", fontWeight: r.daSua ? 700 : 400 }} title="Bấm để sửa" onClick={() => sua(r)}>{r.soNgay}</td>
                <td style={td}>{ngayCong}</td>
                <td style={td}>{vnd(PC_KIEM_XE_DON_GIA)}</td>
                <td style={{ ...td, fontWeight: 700, color: "#047857" }}>{vnd(r.tien)}</td>
                <td style={td}>{r.trongDs && (<button type="button" title="Bỏ khỏi danh sách kiểm xe" onClick={() => boNguoi(r)} style={{ border: "none", background: "transparent", color: "#dc2626", cursor: "pointer", fontSize: 14 }}>✕</button>)}</td>
              </tr>
            ))}
            <tr>
              <td style={{ ...td, background: "#ecfdf5", fontWeight: 700, textAlign: "left" }} colSpan={5}>Tổng cộng</td>
              <td style={{ ...td, background: "#ecfdf5", fontWeight: 700, fontSize: 15, color: "#047857" }}>{vnd(tong)}</td>
              <td style={{ ...td, background: "#ecfdf5" }} />
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

// Tab "Thu nhập" (phía admin) — áp cùng công thức với "Xem thu nhập" của
// từng GV (phí CK theo ngân hàng, thuế TNCN 10%/hỗ trợ 5% chỉ Thỉnh giảng,
// trừ vi phạm Chưa xử lý đúng tháng) lên TỪNG DÒNG của bảng Chấm công tháng
// đang chọn — để admin duyệt trước khi trả lương cho cả trường trong 1 bảng.
// Diễn giải lương theo ngày công (Lương cơ bản × tỷ lệ × ngày làm/ngày chuẩn) —
// chỉ có khi admin nhập lương cơ bản + ngày công ở bảng Chấm công tháng.
const luongNgayCongText = (r) => {
  const cb = Number(r.luongCoBan) || 0, chuan = Number(r.congChuan) || 0, lam = Number(r.congThucTe) || 0, ty = Number(r.tyLeHuong) || 0;
  if (cb <= 0 || chuan <= 0 || lam <= 0) return "";
  return `${cb.toLocaleString("vi-VN")}${ty > 0 && ty < 100 ? ` × ${ty}%` : ""} × ${lam}/${chuan} ngày`;
};

// treoMode: tab "⏸ Treo lương" — chỉ hiện người bị treo lương tháng này (tab Thu nhập thì ẩn họ đi).
const ThuNhapAdminTab = ({ schoolId, monthKey, treoMode = false }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [loc, setLoc] = useState("all"); // all | thpt | nghe
  const [reload, setReload] = useState(0);

  useEffect(() => {
    if (!schoolId || !monthKey) return;
    setLoading(true);
    setError("");
    getChamCongThangThuNhap(schoolId, monthKey)
      .then(setData)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [schoolId, monthKey, reload]);

  if (loading) return <p>Đang tải...</p>;
  if (error) return <p style={{ color: "#dc2626" }}>{error}</p>;
  if (!data) return null;
  const isNghe = (r) => String(r.loai || "").normalize("NFC") === "GV Nghề";
  const baseRows = data.rows.filter((r) => (treoMode ? r.treoLuong : !r.treoLuong));
  const rows = baseRows.filter((r) => (loc === "all" ? true : loc === "nghe" ? isNghe(r) : !isNghe(r)));
  const grandThucNhan = rows.reduce((a, r) => a + (Number(r.thucNhan) || 0), 0);
  const locLabel = (treoMode ? " — treo lương" : "") + (loc === "nghe" ? " (GV Nghề)" : loc === "thpt" ? " (GV THPT)" : "");
  const treoNames = data.treoLuongNames || [];
  const luuTreo = async (names) => { try { await saveTreoLuong(schoolId, monthKey, names); setReload((k) => k + 1); } catch (e) { window.alert(e.message || "Không lưu được."); } };
  const themTreo = () => {
    const ten = window.prompt(`Họ tên người treo lương ${monthLabelOf(monthKey)} (đúng như bảng Thu nhập):`, "");
    if (ten && ten.trim()) luuTreo([...treoNames, ten.trim()]);
  };
  const boTreo = (hoten) => {
    if (!window.confirm(`Bỏ treo lương ${hoten} — đưa về tab Thu nhập?`)) return;
    const k = (x) => String(x || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[đĐ]/g, "d").toLowerCase().replace(/\s+/g, " ").trim();
    luuTreo(treoNames.filter((n) => k(n) !== k(hoten)));
  };

  // Cột hiện theo dữ liệu: khoản phụ cấp/khoản trừ chỉ hiện khi có ít nhất 1
  // người có số > 0, để bảng toàn trường không quá rộng.
  const has = (key) => rows.some((r) => (Number(r[key]) || 0) > 0);
  const hasBasis = has("luongCoBan");
  const colsAll = [
    ...(hasBasis ? [
      { id: "luongCoBan", label: "Lương cơ bản", kind: "info", get: (r) => r.luongCoBan },
      { id: "ngayCong", label: "Ngày công (làm/chuẩn)", kind: "info", get: (r) => r.congThucTe, text: (r) => (r.congChuan > 0 ? `${r.congThucTe}/${r.congChuan}` : "") },
      ...(has("tyLeHuong") ? [{ id: "tyLeHuong", label: "Tỷ lệ hưởng", kind: "info", get: (r) => r.tyLeHuong, text: (r) => (r.tyLeHuong > 0 ? `${r.tyLeHuong}%${r.luongGhiChu ? ` (${r.luongGhiChu})` : ""}` : "") }] : []),
    ] : []),
    { id: "luong", label: hasBasis ? "Lương theo ngày công" : "Lương, PC giảng dạy", kind: "base", get: (r) => r.tongChamCong, note: (r) => (r.tietThem ? `Gồm +${r.tietThem} tiết${r.tietThemNoiDung ? `: ${r.tietThemNoiDung}` : ""}` : "") },
    { id: "khaoSat", label: "Khảo sát", kind: "plus", get: (r) => r.khaoSat },
    ...(has("coiThi") ? [{ id: "coiThi", label: "Coi thi khảo sát", kind: "plus", get: (r) => r.coiThi, note: (r) => (r.tietCoiThi ? `${r.tietCoiThi} tiết` : "") }] : []),
    ...[
      ["hotroTinHoc", "Hỗ trợ Tin học"], ["phuCapChuyenMon", "Chuyên môn"], ["phuCapChucVu", "Chức vụ/GVCN"],
      ["phuCapDienThoai", "Điện thoại"], ["phuCapXangXe", "Xăng xe"], ["phuCapAn", "Ăn"], ["phuCapKhac", "Phụ cấp khác"], ["luongCaDem", "Lương ca đêm"], ["kiemXe", "Tiền kiểm xe"],
    ].filter(([k]) => has(k)).map(([k, label]) => ({ id: k, label, kind: "plus", get: (r) => r[k] })),
    ...(has("thuNhapKhac") ? [{ id: "thuNhapKhac", label: "Các thu nhập khác", kind: "plus", get: (r) => r.thuNhapKhac, note: (r) => r.thuNhapKhacNoiDung }] : []),
    ...(has("quaTang") ? [{ id: "quaTang", label: `🎁 ${data.quaTangNoiDung || "Quà tặng"}`, kind: "plus", get: (r) => r.quaTang }] : []),
    ...(has("quaTangNT") ? [{ id: "quaTangNT", label: `🎁 ${data.quaTangNTNoiDung || "Quà Nhà trường"}`, kind: "plus", get: (r) => r.quaTangNT }] : []),
    { id: "tongThuNhap", label: "Tổng thu nhập", kind: "total", get: (r) => (Number(r.tongChamCong) || 0) + (Number(r.khaoSat) || 0) + (Number(r.coiThi) || 0) + ["hotroTinHoc", "phuCapChuyenMon", "phuCapChucVu", "phuCapDienThoai", "phuCapXangXe", "phuCapAn", "phuCapKhac", "luongCaDem", "kiemXe", "thuNhapKhac", "quaTang", "quaTangNT"].reduce((s, k) => s + (Number(r[k]) || 0), 0) },
    { id: "tongTru", label: "Trừ vi phạm", kind: "minus", get: (r) => r.tongTru },
    ...(has("khoanTruKhac") ? [{ id: "khoanTruKhac", label: "Khoản trừ khác", kind: "minus", get: (r) => r.khoanTruKhac, note: (r) => r.khoanTruKhacNoiDung }] : []),
    ...(has("tamUng") ? [{ id: "tamUng", label: "💸 Tạm ứng lương", kind: "minus", get: (r) => r.tamUng }] : []),
    { id: "phiCK", label: "Phí CK", kind: "minus", get: (r) => r.phiCK },
    ...(has("bhxh") ? [{ id: "bhxh", label: "BHXH", kind: "minus", get: (r) => r.bhxh }] : []),
    ...(has("phiCongDoan") ? [{ id: "phiCongDoan", label: "Phí công đoàn", kind: "minus", get: (r) => r.phiCongDoan }] : []),
    // Thuế TNCN: GỘP 1 cột = thuế trừ trực tiếp (GV Nghề 10%...) + thuế 10% tự tính (Thỉnh giảng).
    { id: "thueAuto", label: "Thuế TNCN", kind: "minus", get: (r) => (Number(r.thueTNCN) || 0) + (Number(r.thueTNCNTru) || 0) },
    { id: "hoTroAuto", label: "Hỗ trợ", kind: "plus", get: (r) => r.hoTro },
    // Hưởng theo tỷ lệ (vd chưa có bằng -> 80% thu nhập): phần bị giảm, ghi chú lý do.
    ...(has("giamTyLeHuong") ? [{ id: "giamTyLeHuong", label: "Giảm tỷ lệ hưởng", kind: "minus", get: (r) => r.giamTyLeHuong, note: (r) => (r.tyLeHuong ? `Hưởng ${r.tyLeHuong}% thu nhập${/\(([^)]*)\)/.test(r.luongGhiChu || "") ? ` (${(r.luongGhiChu.match(/\(([^)]*)\)/) || [])[1]})` : ""}` : "") }] : []),
  ];
  const renderCell = (c, r) => {
    const v = Number(c.get(r)) || 0;
    if (c.kind === "info") {
      const t = c.text ? c.text(r) : (v > 0 ? `${vnd(v)}` : "");
      return <td key={c.id} style={{ ...td, color: "#374151" }}>{t || "—"}</td>;
    }
    if (c.kind === "base") {
      const lt = luongNgayCongText(r);
      return (
        <td key={c.id} style={td}>
          {vnd(v)}
          {lt && <div style={{ fontSize: 11, color: "#6b7280", fontWeight: 400, marginTop: 2 }}>{lt}</div>}
          {c.note && c.note(r) && <div style={{ fontSize: 11, color: "#6b7280", fontWeight: 400, marginTop: 2 }}>{c.note(r)}</div>}
        </td>
      );
    }
    if (c.kind === "total") return <td key={c.id} style={{ ...td, fontWeight: 700, background: "#f0fdf4" }}>{vnd(v)}</td>;
    const color = v > 0 ? (c.kind === "plus" ? "#0f766e" : "#dc2626") : "#6b7280";
    const sign = c.kind === "plus" ? "+" : "-";
    return (
      <td key={c.id} style={{ ...td, color }}>
        {v > 0 ? `${sign}${vnd(v)}` : "0"}
        {c.note && v > 0 && c.note(r) && (
          <div style={{ fontSize: 11, color: "#6b7280", fontWeight: 400, marginTop: 2 }}>{c.note(r)}</div>
        )}
      </td>
    );
  };

  const exportExcel = () => {
    const header = ["Họ và tên", "Loại", "Ngân hàng", ...colsAll.map((c) => c.label), "Thực nhận", "Ghi chú"];
    const textCols = new Set(); // cột chữ (info có text) — không định dạng tiền
    const rowsX = rows.map((r) => [
      r.hoten, r.loai || "", r.bankAmbiguous ? "trùng tên" : (r.bankName || ""),
      ...colsAll.map((c, i) => {
        if (c.kind === "info") { if (c.text) { textCols.add(3 + i); return c.text(r) || ""; } const v = Number(c.get(r)) || 0; return v || ""; }
        return Number(c.get(r)) || 0;
      }),
      Number(r.thucNhan) || 0,
      // Ghi chú: lý do các khoản (khoản trừ khác, thu nhập khác, tỷ lệ hưởng...).
      colsAll.filter((c) => c.note && (Number(c.get(r)) || 0) > 0 && c.note(r)).map((c) => `${c.label}: ${c.note(r)}`).join("; "),
    ]);
    const moneyCols = [...colsAll.map((c, i) => (c.id === "luongCoBan" || c.kind !== "info" ? 3 + i : -1)).filter((x) => x >= 0), 3 + colsAll.length];
    const sumCol = (i) => rowsX.reduce((s, r) => s + (typeof r[i] === "number" ? r[i] : 0), 0);
    const totalRow = ["Tổng cộng", "", "", ...colsAll.map((c, i) => (c.kind === "info" ? "" : sumCol(3 + i))), grandThucNhan || sumCol(3 + colsAll.length), ""];
    // Công thức Excel: Tổng thu nhập = SUM(lương + các khoản cộng đứng trước); Thực nhận = Tổng thu nhập − các khoản trừ + Hỗ trợ.
    const iTong = colsAll.findIndex((c) => c.id === "tongThuNhap");
    const congTruoc = colsAll.map((c, i) => ((c.kind === "base" || c.kind === "plus") && i < iTong ? 3 + i : -1)).filter((x) => x >= 0);
    const congSau = colsAll.map((c, i) => (c.kind === "plus" && i > iTong ? 3 + i : -1)).filter((x) => x >= 0);
    const tru = colsAll.map((c, i) => (c.kind === "minus" ? 3 + i : -1)).filter((x) => x >= 0);
    const sumF = (refs) => (refs.length ? `SUM(${refs.join(",")})` : "0");
    const rowFormulas = iTong < 0 ? [] : [
      { col: 3 + iTong, refs: congTruoc, f: (refs) => sumF(refs), calc: (n) => n.reduce((a, b) => a + b, 0) },
      { col: 3 + colsAll.length, refs: [3 + iTong, ...tru, ...congSau],
        f: (refs) => `${refs[0]}-${sumF(refs.slice(1, 1 + tru.length))}+${sumF(refs.slice(1 + tru.length))}`,
        calc: (n) => n[0] - n.slice(1, 1 + tru.length).reduce((a, b) => a + b, 0) + n.slice(1 + tru.length).reduce((a, b) => a + b, 0) },
    ];
    return exportTableExcel({ title: `Thu nhập giáo viên${locLabel} — ${monthLabelOf(monthKey)}`, sheetName: "Thu nhập", fileName: `thu_nhap_${loc === "all" ? "" : loc + "_"}${monthKey}.xlsx`, header, rows: rowsX, moneyCols, totalRow, rowFormulas });
  };

  // 🖨 In: mở cửa sổ in bảng đang lọc (khổ A4 ngang), có cột Ký nhận + chỗ ký cuối trang.
  const printList = () => {
    const esc = (x) => String(x ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const money = (v) => (Number(v) ? Math.round(Number(v)).toLocaleString("vi-VN") : "0");
    const cellText = (c, r) => {
      const v = Number(c.get(r)) || 0;
      if (c.kind === "info") return c.text ? (c.text(r) || "") : (v ? money(v) : "");
      if (c.kind === "minus") return v ? `-${money(v)}` : "0";
      return money(v);
    };
    const sumOf = (c) => rows.reduce((t, r) => t + (Number(c.get(r)) || 0), 0);
    // Bản in bỏ cột Ngân hàng, Khảo sát, Trừ vi phạm, Ký nhận.
    const cols = colsAll.filter((c) => !["khaoSat", "tongTru"].includes(c.id));
    const head = `<tr><th>STT</th><th>Họ và tên</th><th>Loại</th>${cols.map((c) => `<th>${esc(c.label)}</th>`).join("")}<th>Thực nhận</th></tr>`;
    const body = rows.map((r, i) => `<tr><td class="c">${i + 1}</td><td class="l b">${esc(r.hoten)}</td><td class="c">${esc(r.loai)}</td>${cols.map((c) => `<td>${esc(cellText(c, r))}</td>`).join("")}<td class="b">${money(r.thucNhan)}</td></tr>`).join("");
    const foot = `<tr class="tot"><td colspan="3" class="l b">Tổng cộng (${rows.length} người)</td>${cols.map((c) => `<td>${c.kind === "info" ? "" : esc((c.kind === "minus" && sumOf(c) ? "-" : "") + money(sumOf(c)))}</td>`).join("")}<td class="b">${money(grandThucNhan)}</td></tr>`;
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>Thu nhập ${esc(monthLabelOf(monthKey))}</title>
<style>@page{size:A4 landscape;margin:10mm}body{font-family:"Times New Roman",serif;font-size:11px;color:#000}
h2{text-align:center;margin:0 0 2px;font-size:16px}.sub{text-align:center;margin:0 0 8px}
table{border-collapse:collapse;width:100%}th,td{border:1px solid #000;padding:3px 4px;text-align:right;vertical-align:middle}
th{background:#eee;text-align:center;font-size:10px}td.l{text-align:left}td.c{text-align:center}.b{font-weight:bold}td:nth-child(2){white-space:nowrap}
.ky{min-width:70px}tr{page-break-inside:avoid}thead{display:table-header-group}.tot td{background:#f3f3f3}
.sign{display:flex;justify-content:space-around;margin-top:18px;text-align:center}.sign div{width:30%}.sign i{font-weight:normal}</style></head><body>
<div style="font-weight:bold">TRƯỜNG TRUNG CẤP KINH TẾ - KỸ THUẬT PHAN CHU TRINH</div>
<h2>BẢNG THU NHẬP GIÁO VIÊN${esc(locLabel.toUpperCase())}</h2><p class="sub">${esc(monthLabelOf(monthKey))}</p>
<table><thead>${head}</thead><tbody>${body}${foot}</tbody></table>
<div class="sign"><div><b>Người lập bảng</b><br><i>(Ký, ghi rõ họ tên)</i></div><div><b>Kế toán</b><br><i>(Ký, ghi rõ họ tên)</i></div><div><i>Ngày ...... tháng ...... năm ${esc(String(monthKey).slice(0, 4))}</i><br><b>Hiệu trưởng</b><br><i>(Ký, ghi rõ họ tên)</i></div></div>
<script>window.onload=function(){setTimeout(function(){window.print()},200)}</script></body></html>`;
    const w = window.open("", "_blank");
    if (!w) { window.alert("Trình duyệt chặn cửa sổ in — cho phép popup rồi bấm lại."); return; }
    w.document.open(); w.document.write(html); w.document.close();
  };

  return (
    <div>
      <div style={{ marginBottom: 10, display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>
        {[["all", `Tất cả (${baseRows.length})`], ["thpt", `GV THPT (${baseRows.filter((r) => !isNghe(r)).length})`], ["nghe", `GV Nghề (${baseRows.filter(isNghe).length})`]].map(([k, l]) => (
          <button key={k} type="button" onClick={() => setLoc(k)} style={{ padding: "5px 12px", borderRadius: 6, border: `1px solid ${loc === k ? "#0f766e" : "#d1d5db"}`, background: loc === k ? "#0f766e" : "#fff", color: loc === k ? "#fff" : "#374151", cursor: "pointer", fontSize: 13, fontWeight: 600 }}>{l}</button>
        ))}
        <span style={{ flex: 1 }} />
        {treoMode && <button type="button" onClick={themTreo} style={{ padding: "5px 12px", border: "1px solid #b45309", borderRadius: 6, background: "#fffbeb", color: "#b45309", cursor: "pointer", fontSize: 13, fontWeight: 600 }}>➕ Thêm người treo lương</button>}
        <button type="button" onClick={printList} disabled={rows.length === 0} style={{ padding: "5px 12px", border: "1px solid #374151", borderRadius: 6, background: "#fff", color: "#374151", cursor: rows.length ? "pointer" : "not-allowed", fontSize: 13, fontWeight: 600 }}>🖨 In</button>
        <ExportBtn onClick={exportExcel} disabled={rows.length === 0} />
      </div>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
        Thực nhận = Chấm công (cột "Thành tiền" ở tab Xem chấm công) + Khảo sát + các khoản phụ cấp/hỗ trợ (Hỗ trợ Tin học, Chuyên môn, Chức vụ/GVCN, Điện thoại, Xăng xe, Ăn, Phụ cấp khác, Các thu nhập khác) − Trừ vi phạm (Chưa xử lý, đúng tháng) − Khoản trừ khác − 💸 Tạm ứng lương (tab Tạm ứng lương cùng tháng) − Phí CK ngân hàng (hoặc số ghi đè) − BHXH/Phí công đoàn − Thuế TNCN trừ trực tiếp (nếu có) − Thuế TNCN 10% + Nhà trường hỗ trợ 5% (2 khoản cuối chỉ áp dụng Thỉnh giảng) (Khảo sát/phụ cấp cộng thẳng, khoản trừ khác trừ thẳng, không qua phí/thuế — Khảo sát chỉ hiện ở tháng gần nhất đã kết thúc).
      </p>
      {treoMode && (
        <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
          Người bị treo lương {monthLabelOf(monthKey)}: không tính vào Tổng thực nhận ở tab Thu nhập. Bấm "▶ Bỏ treo" để đưa về tab Thu nhập.
          {Array.isArray(data.treoLuongKhongKhop) && data.treoLuongKhongKhop.length > 0 && <span style={{ color: "#b45309" }}> ⚠️ Không thấy trong bảng Thu nhập: {data.treoLuongKhongKhop.join(", ")}.</span>}
        </p>
      )}
      {Array.isArray(data.quaTangKhongKhop) && data.quaTangKhongKhop.length > 0 && (
        <p style={{ color: "#b45309", fontSize: 13, background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 6, padding: "6px 10px" }}>
          🎁 {data.quaTangKhongKhop.length} người có {data.quaTangNoiDung || "quà tặng"} nhưng không có dòng ở bảng này: {data.quaTangKhongKhop.map((x) => `${x.hoten} (${vnd(x.soTien)} — ${x.lyDo})`).join("; ")}.
        </p>
      )}
      {Array.isArray(data.tamUngKhongKhop) && data.tamUngKhongKhop.length > 0 && (
        <p style={{ color: "#b45309", fontSize: 13, background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 6, padding: "6px 10px" }}>
          ⚠️ {data.tamUngKhongKhop.length} người trong tab Tạm ứng lương CHƯA trừ được vì {data.tamUngKhongKhop.map((x) => `${x.hoten} (${vnd(x.soTien)} — ${x.lyDo})`).join("; ")}.
        </p>
      )}
      {rows.length === 0 ? (
        <p style={{ color: "#6b7280" }}>{treoMode ? "Không có ai bị treo lương tháng này." : "Chưa có dữ liệu chấm công tháng này."}</p>
      ) : (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8 }}>
          <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%" }}>
            <thead>
              <tr>
                <th style={{ ...th, textAlign: "left" }}>Họ và tên</th>
                <th style={th}>Loại</th>
                <th style={th}>Ngân hàng</th>
                {colsAll.map((c) => (<th key={c.id} style={th}>{c.label}</th>))}
                <th style={th}>Thực nhận</th>
                {treoMode && <th style={th} />}
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i}>
                  <td style={{ ...td, textAlign: "left", fontWeight: 600 }}>{r.hoten}</td>
                  <td style={td}>{r.loai}</td>
                  <td style={{ ...td, color: r.bankAmbiguous ? "#dc2626" : "#6b7280" }}>
                    {r.bankAmbiguous ? "⚠️ trùng tên" : (r.bankName || "—")}
                  </td>
                  {colsAll.map((c) => renderCell(c, r))}
                  <td style={{ ...td, fontWeight: 700, color: "#047857" }}>{vnd(r.thucNhan)}</td>
                  {treoMode && <td style={td}><button type="button" onClick={() => boTreo(r.hoten)} style={{ border: "1px solid #0f766e", background: "#fff", color: "#0f766e", borderRadius: 6, padding: "2px 8px", cursor: "pointer", fontSize: 12 }}>▶ Bỏ treo</button></td>}
                </tr>
              ))}
              <tr>
                <td style={{ ...td, textAlign: "left", fontWeight: 700, background: "#ecfdf5" }} colSpan={3 + colsAll.length}>Tổng cộng thực nhận{locLabel}</td>
                <td style={{ ...td, fontWeight: 700, fontSize: 15, color: "#047857", background: "#ecfdf5" }}>{vnd(grandThucNhan)}</td>
                {treoMode && <td style={{ ...td, background: "#ecfdf5" }} />}
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

// Tab "Chấm công theo TKB" — KHÁC tab "Xem chấm công" (bảng gõ tay, admin tự
// nhập "thành tiền" từng tuần): tab này TỰ TÍNH thẳng từ bản TKB đã công bố
// của từng tuần trong tháng (cùng công thức GV tự xem "Xem chấm công của
// chính mình"), không cần ai gõ tay, không sửa/xuất Excel được — chỉ xem.
// Dialog thông tin 1 GV ở "Chấm công theo TKB" (nhấn đúp vào dòng). Các SỐ TIẾT
// lấy từ TKB chỉ để xem, KHÔNG sửa được. Bấm Sửa để chỉnh thông số công thức
// lương Cơ hữu (Tiết tiêu chuẩn, Lương cơ bản, Lương hiệu quả) + ghi chú, bấm
// Ghi để lưu vào Database (PUT .../tu-tkb/:staffId/adjust) — bảng tự tính lại
// Tiết vượt và Tiền. Ô để trống = dùng mặc định. Chỉ áp dụng khi GV đang tính
// theo công thức Cơ hữu (tietChuan > 0); Thỉnh giảng chỉ xem.
const TuTkbDetailDialog = ({ row, schoolId, monthKey, onClose, onSaved }) => {
  const isFT = !!row.fullTime;
  const canEdit = !isFT && !isThinhGiang(row.loai) && row.tietChuan > 0;
  const initFT = (k) => (row.ghiDeFullTime && row.ghiDeFullTime[k] !== null && row.ghiDeFullTime[k] !== undefined ? String(row.ghiDeFullTime[k]) : "");
  const [luongNgayCong, setLuongNgayCong] = useState(initFT("luongNgayCong"));
  const [congThucTe, setCongThucTe] = useState(initFT("congThucTe"));
  const init = (k) => (row.ghiDe && row.ghiDe[k] !== null && row.ghiDe[k] !== undefined ? String(row.ghiDe[k]) : "");
  const [editing, setEditing] = useState(false);
  const [tietChuan, setTietChuan] = useState(init("tietChuan"));
  const [luongCoBan, setLuongCoBan] = useState(init("luongCoBan"));
  const [luongHieuQua, setLuongHieuQua] = useState(init("luongHieuQua"));
  const [ghiChu, setGhiChu] = useState(row.ghiChu || "");
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState("");

  const ghi = async () => {
    setSaving(true); setErr("");
    try {
      await saveChamCongTuTKBAdjust(schoolId, monthKey, row.staffId, { tietChuan, luongCoBan, luongHieuQua, luongNgayCong, congThucTe, ghiChu });
      onSaved();
    } catch (e) { setErr(e.message); setSaving(false); }
  };
  const thangLabel = (mk) => { const [y, m] = String(mk).split("-"); return `tháng ${Number(m)}/${y}`; };
  const thangTruoc = (() => { const [y, m] = monthKey.split("-").map(Number); const t = new Date(Date.UTC(y, m - 2, 1)); return `${t.getUTCFullYear()}-${String(t.getUTCMonth() + 1).padStart(2, "0")}`; })();
  const gop = async (mk, on) => {
    const msg = on
      ? `Gộp toàn bộ ${row.tongTiet ?? (row.tietThuong + row.tietTC)} tiết ${thangLabel(monthKey)} của ${row.hoten} vào ${thangLabel(thangTruoc)}? (${thangLabel(monthKey)} sẽ không còn dòng của GV này)`
      : `Bỏ gộp: trả ${(row.gopTuThangSau.tietThuong || 0) + (row.gopTuThangSau.tietTC || 0)} tiết về lại ${thangLabel(mk)}?`;
    if (!window.confirm(msg)) return;
    setSaving(true); setErr("");
    try { await setGopTuTkb(schoolId, mk, row.staffId, on); onSaved(); } catch (e) { setErr(e.message); setSaving(false); }
  };
  const huy = () => {
    setTietChuan(init("tietChuan")); setLuongCoBan(init("luongCoBan")); setLuongHieuQua(init("luongHieuQua"));
    setLuongNgayCong(initFT("luongNgayCong")); setCongThucTe(initFT("congThucTe"));
    setGhiChu(row.ghiChu || ""); setErr(""); setEditing(false);
  };
  const info = (label, value) => (
    <div style={{ display: "flex", justifyContent: "space-between", gap: 12, padding: "5px 0", borderBottom: "1px solid #f3f4f6", fontSize: 14 }}>
      <span style={{ color: "#6b7280" }}>{label}</span><b>{value}</b>
    </div>
  );
  const field = (label, value, setValue, def) => (
    <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, padding: "5px 0", fontSize: 14 }}>
      <span>{label} <span style={{ color: "#9ca3af", fontSize: 12 }}>(mặc định {vnd(def)})</span></span>
      <input type="number" min="0" value={value} onChange={(e) => setValue(e.target.value)} disabled={!editing} placeholder={String(def)}
        style={{ width: 130, padding: 5, textAlign: "right", border: "1px solid #d1d5db", borderRadius: 6, background: editing ? "#fff" : "#f3f4f6" }} />
    </label>
  );

  return (
    <div style={dlgOverlay} onClick={onClose}>
      <div style={dlgBox} onClick={(e) => e.stopPropagation()}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
          <h3 style={{ margin: 0 }}>{row.hoten}</h3>
          <button type="button" onClick={onClose} style={{ border: "none", background: "transparent", fontSize: 18, cursor: "pointer" }}>✕</button>
        </div>
        <p style={{ margin: "0 0 10px", color: "#6b7280", fontSize: 13 }}>{monthLabelOf(monthKey)} — chấm công theo TKB</p>

        <div style={{ fontWeight: 700, fontSize: 13, color: "#6b7280", margin: "4px 0" }}>Lấy từ TKB (không sửa được)</div>
        {info("Loại", row.loai || "—")}
        {row.tgLevel && info("Level (cấp bậc)", `${row.tgLevel} — đơn giá TC ${vnd(row.donGiaTC)}đ`)}
        {info("Bộ môn", row.bomon || "—")}
        {info("Số tuần có TKB", row.soTuan)}
        {info("Tiết thường", row.tietThuong)}
        {info("Tiết TC", row.tietTC)}
        {row.lopCN1 && info(`Tiết CN lớp 1 (${row.lopCN1}, 2 tiết/tuần)`, row.tietCN1)}
        {row.lopCN2 && info(`Tiết CN lớp 2 (${row.lopCN2}, 4 tiết/tuần)`, row.tietCN2)}
        {info("Tổng số tiết (CK+TC+CN)", row.tongTiet)}

        <div style={{ fontWeight: 700, fontSize: 13, color: "#6b7280", margin: "14px 0 4px" }}>Thông số tính lương (sửa được)</div>
        {isFT ? (
          <>
            <p style={{ margin: "0 0 6px", color: "#6b7280", fontSize: 13 }}>FullTime: tính theo ngày công, không tính theo tiết. Tiền = Lương tháng × Ngày công thực tế / {row.congChuan}.</p>
            {field("Lương tháng (đủ công)", luongNgayCong, setLuongNgayCong, row.macDinhFullTime.luongNgayCong)}
            <label style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 12, padding: "5px 0", fontSize: 14 }}>
              <span>Ngày công thực tế <span style={{ color: "#9ca3af", fontSize: 12 }}>(mặc định {row.macDinhFullTime.congThucTe} = đủ công)</span></span>
              <input type="number" min="0" max="31" step="0.5" value={congThucTe} onChange={(e) => setCongThucTe(e.target.value)} disabled={!editing} placeholder={String(row.macDinhFullTime.congThucTe)}
                style={{ width: 130, padding: 5, textAlign: "right", border: "1px solid #d1d5db", borderRadius: 6, background: editing ? "#fff" : "#f3f4f6" }} />
            </label>
            <label style={{ display: "block", marginTop: 6, fontSize: 14 }}>Ghi chú
              <textarea value={ghiChu} onChange={(e) => setGhiChu(e.target.value)} disabled={!editing} rows={2}
                placeholder="VD: nghỉ phép 2 ngày, thử việc..."
                style={{ width: "100%", boxSizing: "border-box", marginTop: 4, padding: 6, border: "1px solid #d1d5db", borderRadius: 6, background: editing ? "#fff" : "#f3f4f6" }} />
            </label>
          </>
        ) : canEdit ? (
          <>
            {field("Tiết tiêu chuẩn", tietChuan, setTietChuan, row.macDinh.tietChuan)}
            {field("Lương cơ bản", luongCoBan, setLuongCoBan, row.macDinh.luongCoBan)}
            {field("Lương hiệu quả", luongHieuQua, setLuongHieuQua, row.macDinh.luongHieuQua)}
            <label style={{ display: "block", marginTop: 6, fontSize: 14 }}>Ghi chú
              <textarea value={ghiChu} onChange={(e) => setGhiChu(e.target.value)} disabled={!editing} rows={2}
                placeholder="Lý do chỉnh, VD: nghỉ thai sản, giảm định mức..."
                style={{ width: "100%", boxSizing: "border-box", marginTop: 4, padding: 6, border: "1px solid #d1d5db", borderRadius: 6, background: editing ? "#fff" : "#f3f4f6" }} />
            </label>
          </>
        ) : (
          <p style={{ margin: 0, color: "#6b7280", fontSize: 13 }}>Giáo viên này không tính theo công thức lương Cơ hữu nên không có thông số nào để sửa.</p>
        )}

        <div style={{ marginTop: 12, padding: 10, background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: 8, fontSize: 13 }}>
          {row.gopTuThangSau ? (
            <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
              <span>⤴ Đã gộp <b>{(row.gopTuThangSau.tietThuong || 0) + (row.gopTuThangSau.tietTC || 0)} tiết</b> của {thangLabel(row.gopTuThangSau.thang)} vào tháng này ({row.gopTuThangSau.tietThuong} tiết thường, {row.gopTuThangSau.tietTC} tiết TC).</span>
              <button type="button" onClick={() => gop(row.gopTuThangSau.thang, false)} disabled={saving} style={dlgBtnGhost}>Bỏ gộp</button>
            </div>
          ) : (
            <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
              <span>Dạy ít tiết tháng này (vd đã nghỉ đầu tháng)?</span>
              <button type="button" onClick={() => gop(monthKey, true)} disabled={saving} style={dlgBtnGhost}>⤴ Gộp tiết tháng này vào {thangLabel(thangTruoc)}</button>
            </div>
          )}
        </div>
        <div style={{ marginTop: 12 }}>
          {canEdit && info("Tiết vượt chuẩn (hiện tại)", row.tietVuot)}
          {info("Tiền (hiện tại)", vnd(row.tien))}
        </div>
        {(canEdit || isFT) && <p style={{ margin: "6px 0 0", color: "#6b7280", fontSize: 12 }}>Để trống một ô = dùng giá trị mặc định. Sau khi Ghi, Tiền (và Tiết vượt) ở bảng được tính lại.</p>}
        {err && <p style={{ color: "#dc2626", margin: "8px 0 0" }}>{err}</p>}

        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 14 }}>
          {editing ? (
            <>
              <button type="button" onClick={huy} disabled={saving} style={dlgBtnGhost}>Hủy</button>
              <button type="button" onClick={ghi} disabled={saving} style={dlgBtnPrimary}>{saving ? "Đang ghi..." : "Ghi"}</button>
            </>
          ) : (
            <>
              <button type="button" onClick={onClose} style={dlgBtnGhost}>Đóng</button>
              {(canEdit || isFT) && <button type="button" onClick={() => setEditing(true)} style={dlgBtnPrimary}>Sửa</button>}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

// Lương tiết vượt = Tiết vượt × 80.000 (chỉ khi GV tính theo công thức Cơ hữu: tietChuan > 0).
const DON_GIA_TIET_VUOT = 80000;
const DON_GIA_CK = 80000; // đơn giá tiết thường (CK) của GV Thỉnh giảng
const tienCKOf = (r) => (Number(r.tietThuong) || 0) * DON_GIA_CK;
const tienTCOf = (r) => (Number(r.tietTC) || 0) * (Number(r.donGiaTC) || 0);
const tienTGOf = (r) => tienCKOf(r) + tienTCOf(r);
// Đơn giá tiết vượt theo thâm niên (server trả donGiaTietVuot): năm 1 = 80k, năm 2 = 82k, năm 3 = 85k, năm 4+ = 90k.
const donGiaTietVuotOf = (r) => Number(r && r.donGiaTietVuot) || DON_GIA_TIET_VUOT;
const luongTietVuotOf = (r) => (r.tietChuan ? (Number(r.tietVuot) || 0) * donGiaTietVuotOf(r) : 0);

const TU_TKB_LOAI_TABS = [
  { key: "cohuu", label: "Cơ hữu" },
  { key: "thinhgiang", label: "Thỉnh giảng" },
  { key: "fulltime", label: "FullTime" },
];
// Nhóm của 1 dòng: FullTime (tính theo ngày công) tách riêng khỏi Cơ hữu / Thỉnh giảng.
const tkbGroupOf = (r) => (r.fullTime ? "fulltime" : isThinhGiang(r.loai) ? "thinhgiang" : "cohuu");
const isThinhGiang = (loai) => String(loai || "").normalize("NFC").trim() === "Thỉnh giảng";

// Tab "Thu nhập THPT" — toàn bộ GV THPT (Cơ hữu, FullTime, Thỉnh giảng): đủ cột của tab 📋 Chấm công theo TKB + tab 💵 Thu nhập.
const TN_THPT_NHOM = [["cohuu", "Cơ hữu"], ["fulltime", "FullTime"], ["thinhgiang", "Thỉnh giảng"]];
const TN_THPT_COLS = [
  { key: "soTuan", label: "Số tuần có TKB", t: "n", g: "cc" },
  { key: "tietThuong", label: "Tiết thường", t: "n", g: "cc" },
  { key: "tietTC", label: "Tiết TC", t: "n", g: "cc" },
  { key: "soLopCN", label: "Số lớp CN", t: "n", g: "cc" },
  { key: "cn1", label: "Tiết CN Lớp 1", t: "s", g: "cc" },
  { key: "cn2", label: "Tiết CN Lớp 2", t: "s", g: "cc" },
  { key: "soLopTN12", label: "Số lớp dạy TN12", t: "n", g: "cc" },
  { key: "tongTiet", label: "Tổng số tiết (CK+TC+CN)", t: "n", g: "cc" },
  { key: "tietChuan", label: "Tiết tiêu chuẩn", t: "n", g: "cc", noSum: true },
  { key: "tietVuot", label: "Tiết vượt", t: "n", g: "cc" },
  { key: "dgtv", label: "ĐG tiết vượt", t: "m", g: "cc", noSum: true },
  { key: "luongCoBan", label: "Lương cơ bản", t: "m", g: "cc" },
  { key: "luongHieuQua", label: "Lương hiệu quả", t: "m", g: "cc" },
  { key: "ltv", label: "Lương tiết vượt", t: "m", g: "cc" },
  { key: "tienTN12", label: "Tiền TN12", t: "m", g: "cc" },
  { key: "htdt", label: "HT ĐT", t: "m", g: "cc" },
  { key: "luongNgayCong", label: "Lương tháng (đủ công)", t: "m", g: "cc", noSum: true },
  { key: "congChuan", label: "Ngày công chuẩn", t: "n", g: "cc", noSum: true },
  { key: "congThucTe", label: "Ngày công thực tế", t: "n", g: "cc", noSum: true },
  { key: "tgLevel", label: "Level TG", t: "s", g: "cc" },
  { key: "donGiaCK", label: "Đơn giá CK", t: "m", g: "cc", noSum: true },
  { key: "donGiaTC", label: "Đơn giá TC", t: "m", g: "cc", noSum: true },
  { key: "tienCK", label: "Tiền CK", t: "m", g: "cc" },
  { key: "tienTC", label: "Tiền TC", t: "m", g: "cc" },
  { key: "tienTkb", label: "Tiền (TKB)", t: "m", g: "cc", total: true },
  { key: "tongChamCong", label: "Chấm công (Thu nhập)", t: "m", g: "tn", total: true },
  { key: "phuCap", label: "Phụ cấp", t: "m", g: "tn" },
  { key: "kiemXe", label: "Kiểm xe", t: "m", g: "tn" },
  { key: "khaoSat", label: "Khảo sát", t: "m", g: "tn" },
  { key: "coiThi", label: "Coi thi khảo sát", t: "m", g: "tn" },
  { key: "thuNhapKhac", label: "Thu nhập khác", t: "m", g: "tn", note: "thuNhapKhacNoiDung" },
  { key: "quaTang", label: "Quà 20-10(HS)", t: "m", g: "tn" },
  { key: "quaTangNT", label: "Quà 20-10(NT)", t: "m", g: "tn" },
  { key: "hoTro", label: "NT hỗ trợ 5%", t: "m", g: "tn" },
  { key: "tongThuNhap", label: "Tổng thu nhập", t: "m", g: "tn", total: true },
  { key: "bhxh", label: "BHXH", t: "m", g: "tn", minus: true },
  { key: "phiCongDoan", label: "Công đoàn", t: "m", g: "tn", minus: true },
  { key: "thue", label: "Thuế TNCN", t: "m", g: "tn", minus: true },
  { key: "tongTru", label: "Trừ vi phạm", t: "m", g: "tn", minus: true },
  { key: "khoanTruKhac", label: "Khoản trừ khác", t: "m", g: "tn", minus: true, note: "khoanTruKhacNoiDung" },
  { key: "tamUng", label: "Tạm ứng", t: "m", g: "tn", minus: true },
  { key: "phiCK", label: "Phí CK", t: "m", g: "tn", minus: true },
  { key: "thucNhan", label: "Thực nhận", t: "m", g: "tn", total: true },
];
const ThuNhapThptTab = ({ schoolId, monthKey }) => {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState("");
  const [loc, setLoc] = useState("all");
  useEffect(() => {
    if (!schoolId) return;
    setRows(null); setErr("");
    Promise.all([getChamCongThangThuNhap(schoolId, monthKey), getChamCongThangTuTKB(schoolId, monthKey).catch(() => ({ rows: [] }))])
      .then(([tn, tkb]) => {
        const fk = (x) => String(x || "").normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/đ/gi, "d").toLowerCase().replace(/\s+/g, " ").trim();
        const N = (v) => Number(v) || 0;
        const tkbBy = {}; ((tkb && tkb.rows) || []).forEach((x) => { tkbBy[fk(x.hoten)] = x; });
        const PC = ["hotroTinHoc", "phuCapChuyenMon", "phuCapChucVu", "phuCapDienThoai", "phuCapXangXe", "phuCapAn", "phuCapKhac", "luongCaDem"];
        const list = ((tn && tn.rows) || []).filter((r) => String(r.loai || "").normalize("NFC") !== "GV Nghề").map((r) => {
          const d = tkbBy[fk(r.hoten)] || null;
          const nhom = d ? tkbGroupOf(d) : isThinhGiang(r.loai) ? "thinhgiang" : "cohuu";
          const tg = nhom === "thinhgiang", ft = nhom === "fulltime";
          const o = { hoten: r.hoten, loai: r.loai || (d && d.loai) || "", nhom, treoLuong: !!r.treoLuong, bankName: r.bankName || "",
            thuNhapKhacNoiDung: r.thuNhapKhacNoiDung || "", khoanTruKhacNoiDung: r.khoanTruKhacNoiDung || "" };
          if (d) {
            Object.assign(o, {
              soTuan: N(d.soTuan), tietThuong: N(d.tietThuong), tietTC: N(d.tietTC), soLopCN: N(d.soLopCN),
              cn1: d.lopCN1 ? `${d.tietCN1} (${d.lopCN1})` : "", cn2: d.lopCN2 ? `${d.tietCN2} (${d.lopCN2})` : "",
              soLopTN12: N(d.soLopTN12), tongTiet: N(d.tongTiet), tietChuan: N(d.tietChuan), tietVuot: d.tietChuan ? N(d.tietVuot) : 0,
              dgtv: d.tietChuan ? donGiaTietVuotOf(d) : 0, luongCoBan: N(d.luongCoBan), luongHieuQua: N(d.luongHieuQua), ltv: luongTietVuotOf(d),
              tienTN12: N(d.tienTN12), htdt: N(d.tienDienThoai),
              luongNgayCong: ft ? N(d.luongNgayCong) : 0, congChuan: ft ? N(d.congChuan) : 0, congThucTe: ft ? N(d.congThucTe) : 0,
              tgLevel: tg && d.tgLevel ? String(d.tgLevel) : "", donGiaCK: tg ? DON_GIA_CK : 0, donGiaTC: tg ? N(d.donGiaTC) : 0,
              tienCK: tg ? tienCKOf(d) : 0, tienTC: tg ? tienTCOf(d) : 0, tienTkb: tg ? tienTGOf(d) : N(d.tien),
            });
          }
          Object.assign(o, {
            tongChamCong: N(r.tongChamCong), phuCap: PC.reduce((a, k) => a + N(r[k]), 0), kiemXe: N(r.kiemXe), khaoSat: N(r.khaoSat), coiThi: N(r.coiThi), thuNhapKhac: N(r.thuNhapKhac),
            quaTang: N(r.quaTang), quaTangNT: N(r.quaTangNT), hoTro: Math.round(N(r.hoTro)),
            bhxh: N(r.bhxh), phiCongDoan: N(r.phiCongDoan), thue: Math.round(N(r.thueTNCN) + N(r.thueTNCNTru)), tongTru: N(r.tongTru), khoanTruKhac: N(r.khoanTruKhac),
            tamUng: N(r.tamUng), phiCK: N(r.phiCK), thucNhan: Math.round(N(r.thucNhan)),
          });
          o.tongThuNhap = o.tongChamCong + o.phuCap + o.kiemXe + o.khaoSat + o.coiThi + o.thuNhapKhac + o.quaTang + o.quaTangNT + o.hoTro;
          return o;
        });
        const ord = { cohuu: 0, fulltime: 1, thinhgiang: 2 };
        list.sort((a, b) => ord[a.nhom] - ord[b.nhom] || a.hoten.localeCompare(b.hoten, "vi"));
        setRows(list);
      })
      .catch((e) => setErr(e.message || "Không tải được."));
  }, [schoolId, monthKey]);
  if (err) return <p style={{ color: "#dc2626" }}>{err}</p>;
  if (!rows) return <p>Đang tải...</p>;
  const shown = loc === "all" ? rows : rows.filter((r) => r.nhom === loc);
  const cols = TN_THPT_COLS.filter((c) => c.total || shown.some((r) => r[c.key])); // ẩn cột không ai có số (vd đang lọc Cơ hữu thì ẩn cột Thỉnh giảng)
  const sumCol = (list, c) => (c.t === "s" || c.noSum ? "" : list.filter((r) => !(c.key === "thucNhan" && r.treoLuong)).reduce((a, r) => a + (Number(r[c.key]) || 0), 0));
  const ccN = cols.filter((c) => c.g === "cc").length, tnN = cols.length - ccN;
  const fmt = (c, v) => (c.t === "s" ? (v || "") : c.t === "n" ? (v || "") : v ? vnd(v) : "");
  const tieuDe = loc === "all" ? "" : ` — ${(TN_THPT_NHOM.find((x) => x[0] === loc) || [])[1]}`;
  const exportExcel = () => exportTableExcel({
    title: `Thu nhập GV THPT${tieuDe} — ${monthLabelOf(monthKey)}`, sheetName: "Thu nhập THPT", fileName: `thu_nhap_thpt_${monthKey}.xlsx`,
    header: ["STT", "Họ và tên", "Nhóm", "Loại", ...TN_THPT_COLS.map((c) => c.label), "Ngân hàng", "Ghi chú"],
    rows: shown.map((r, i) => [i + 1, r.hoten, (TN_THPT_NHOM.find((x) => x[0] === r.nhom) || [])[1], r.loai, ...TN_THPT_COLS.map((c) => (c.t === "s" ? r[c.key] || "" : r[c.key] || 0)), r.bankName,
      [r.treoLuong ? "Treo lương" : "", r.thuNhapKhacNoiDung && `+ ${r.thuNhapKhacNoiDung}`, r.khoanTruKhacNoiDung && `− ${r.khoanTruKhacNoiDung}`].filter(Boolean).join("; ")]),
    moneyCols: TN_THPT_COLS.map((c, i) => (c.t === "m" ? 4 + i : -1)).filter((i) => i >= 0),
    totalRow: ["", "Tổng cộng", "", "", ...TN_THPT_COLS.map((c) => sumCol(shown, c)), "", ""],
  });
  const printList = () => {
    const esc = (x) => String(x ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const m = (c, v) => (c.t === "m" ? (v ? Math.round(v).toLocaleString("vi-VN") : "") : (v || ""));
    const pcc = cols.filter((c) => c.g === "cc").length, ptn = cols.length - pcc;
    let nt = null; let stt = 0;
    const body = shown.map((r) => {
      const h = r.nhom !== nt ? `<tr><td colspan="${cols.length + 2}" class="l b grp">${esc((TN_THPT_NHOM.find((x) => x[0] === r.nhom) || [])[1])}</td></tr>` : "";
      nt = r.nhom; stt += 1;
      return h + `<tr><td class="c">${stt}</td><td class="l b">${esc(r.hoten)}${r.treoLuong ? " <i>(treo)</i>" : ""}</td>${cols.map((c) => `<td class="${c.total ? "b" : ""}${c.t !== "m" ? " c" : ""}">${esc(m(c, r[c.key]))}</td>`).join("")}</tr>`;
    }).join("");
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>Thu nhập GV THPT ${esc(monthLabelOf(monthKey))}</title>
<style>@page{size:A4 landscape;margin:5mm}body{font-family:"Times New Roman",serif;font-size:8.5px;color:#000}h2{text-align:center;margin:2px 0}.sub{text-align:center;margin:0 0 5px}
table{border-collapse:collapse;width:100%}th,td{border:1px solid #000;padding:2px 2px;text-align:right}th{background:#eee;text-align:center;font-size:8px}
td.l{text-align:left}td.c{text-align:center}.b{font-weight:bold}.grp{background:#f1f5f9}tr{page-break-inside:avoid}thead{display:table-header-group}.tot td{background:#f3f3f3;font-weight:bold}.g th{background:#ddd;font-size:9px}
.sign{display:flex;justify-content:space-around;margin-top:14px;text-align:center}.sign div{width:30%}</style></head><body>
<div style="font-weight:bold">TRƯỜNG TRUNG CẤP KINH TẾ - KỸ THUẬT PHAN CHU TRINH</div>
<h2>BẢNG THU NHẬP GIÁO VIÊN THPT${esc(tieuDe.toUpperCase())}</h2><p class="sub">${esc(monthLabelOf(monthKey))}</p>
<table><thead><tr class="g"><th rowspan="2">STT</th><th rowspan="2">Họ và tên</th><th colspan="${pcc}">CHẤM CÔNG THEO TKB</th><th colspan="${ptn}">THU NHẬP</th></tr>
<tr>${cols.map((c) => `<th>${esc(c.label)}</th>`).join("")}</tr></thead>
<tbody>${body}<tr class="tot"><td></td><td class="l">Tổng cộng (${shown.length} người)</td>${cols.map((c) => { const v = sumCol(shown, c); return `<td class="${c.t !== "m" ? "c" : ""}">${v === "" ? "" : esc(m(c, v))}</td>`; }).join("")}</tr></tbody></table>
<div class="sign"><div><b>Người lập bảng</b><br><i>(Ký, ghi rõ họ tên)</i></div><div><b>Kế toán</b><br><i>(Ký, ghi rõ họ tên)</i></div><div><i>Ngày ...... tháng ...... năm ${esc(String(monthKey).slice(0, 4))}</i><br><b>Hiệu trưởng</b><br><i>(Ký, ghi rõ họ tên)</i></div></div>
<script>window.onload=function(){setTimeout(function(){window.print()},200)}</script></body></html>`;
    const w = window.open("", "_blank");
    if (!w) { window.alert("Trình duyệt chặn cửa sổ in — cho phép popup rồi bấm lại."); return; }
    w.document.open(); w.document.write(html); w.document.close();
  };
  let nhomTruoc = null;
  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 8, flexWrap: "wrap" }}>
        {[["all", `Tất cả (${rows.length})`], ...TN_THPT_NHOM.map(([k, l]) => [k, `${l} (${rows.filter((r) => r.nhom === k).length})`])].map(([k, l]) => (
          <button key={k} type="button" onClick={() => setLoc(k)} style={{ padding: "5px 12px", borderRadius: 999, border: "1px solid #0f766e", background: loc === k ? "#0f766e" : "#fff", color: loc === k ? "#fff" : "#0f766e", cursor: "pointer", fontSize: 13, fontWeight: 600 }}>{l}</button>
        ))}
        <span style={{ flex: 1 }} />
        <button type="button" onClick={printList} disabled={shown.length === 0} style={{ padding: "5px 12px", border: "1px solid #374151", borderRadius: 6, background: "#fff", color: "#374151", cursor: shown.length ? "pointer" : "not-allowed", fontSize: 13, fontWeight: 600 }}>🖨 In</button>
        <ExportBtn onClick={exportExcel} disabled={shown.length === 0} />
      </div>
      <p style={{ color: "#6b7280", fontSize: 13, margin: "0 0 8px" }}>
        Gộp tab 📋 Chấm công theo TKB (cách ra Tiền) và tab 💵 Thu nhập (cộng/trừ ra Thực nhận) — chỉ xem, sửa ở tab gốc. Ẩn cột không ai có số (vd lọc Cơ hữu thì ẩn cột của Thỉnh giảng); Export Excel luôn đủ tất cả cột. Người treo lương không tính vào tổng Thực nhận.
      </p>
      {shown.length === 0 ? <p style={{ color: "#6b7280" }}>Không có dữ liệu.</p> : (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8 }}>
          <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%" }}>
            <thead>
              <tr><th style={th} rowSpan={2}>STT</th><th style={{ ...th, textAlign: "left" }} rowSpan={2}>Họ và tên</th><th style={{ ...th, background: "#e0f2fe" }} colSpan={ccN}>📋 CHẤM CÔNG THEO TKB</th><th style={{ ...th, background: "#fef3c7" }} colSpan={tnN}>💵 THU NHẬP</th></tr>
              <tr>{cols.map((c) => (<th key={c.key} style={{ ...th, whiteSpace: "normal", background: c.minus ? "#fef2f2" : c.total ? "#ecfdf5" : th.background }}>{c.label}</th>))}</tr>
            </thead>
            <tbody>
              {shown.map((r, i) => {
                const header = r.nhom !== nhomTruoc; nhomTruoc = r.nhom;
                return (
                  <React.Fragment key={r.hoten + i}>
                    {header && (<tr><td colSpan={cols.length + 2} style={{ ...td, textAlign: "left", fontWeight: 700, background: "#f1f5f9" }}>{(TN_THPT_NHOM.find((x) => x[0] === r.nhom) || [])[1]} ({shown.filter((x) => x.nhom === r.nhom).length})</td></tr>)}
                    <tr style={r.treoLuong ? { background: "#fff7ed" } : undefined}>
                      <td style={td}>{i + 1}</td>
                      <td style={{ ...td, textAlign: "left", fontWeight: 600, whiteSpace: "nowrap" }}>{r.hoten}{r.treoLuong ? <span style={{ color: "#c2410c", fontWeight: 400 }}> (treo lương)</span> : null}</td>
                      {cols.map((c) => (<td key={c.key} title={c.note ? r[c.note] : undefined} style={{ ...td, textAlign: c.t === "m" ? "right" : "center", whiteSpace: "nowrap", fontWeight: c.total ? 700 : 400, color: c.key === "thucNhan" ? "#047857" : c.minus && r[c.key] ? "#dc2626" : undefined }}>{fmt(c, r[c.key])}</td>))}
                    </tr>
                  </React.Fragment>
                );
              })}
              <tr>
                <td style={{ ...td, background: "#ecfdf5" }} />
                <td style={{ ...td, background: "#ecfdf5", fontWeight: 700, textAlign: "left" }}>Tổng cộng ({shown.length} người)</td>
                {cols.map((c) => { const v = sumCol(shown, c); return (<td key={c.key} style={{ ...td, background: "#ecfdf5", fontWeight: 700, textAlign: c.t === "m" ? "right" : "center", color: c.key === "thucNhan" ? "#047857" : undefined }}>{v === "" ? "" : fmt(c, v)}</td>); })}
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const ChamCongTuTkbTab = ({ schoolId, monthKey }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [loaiTab, setLoaiTab] = useState("cohuu");
  const [detailRow, setDetailRow] = useState(null); // dòng đang mở dialog (nhấn đúp)
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    if (!schoolId || !monthKey) return;
    setLoading(true);
    setError("");
    getChamCongThangTuTKB(schoolId, monthKey)
      .then(setData)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [schoolId, monthKey, reloadKey]);

  if (loading) return <p>Đang tải...</p>;
  if (error) return <p style={{ color: "#dc2626" }}>{error}</p>;
  if (!data) return null;

  // Thỉnh giảng = đúng loại "Thỉnh giảng" (được tính tiền theo tiết); còn lại
  // (Cơ hữu, Cơ hữu theo tiết, chưa gắn loại...) gộp chung tab "Cơ hữu".
  const rows = data.rows.filter((r) => tkbGroupOf(r) === loaiTab);
  const grand = rows.reduce((acc, r) => ({
    tietThuong: acc.tietThuong + r.tietThuong, tietTC: acc.tietTC + r.tietTC, tien: acc.tien + r.tien,
    tietCN1: acc.tietCN1 + (r.tietCN1 || 0), tietCN2: acc.tietCN2 + (r.tietCN2 || 0), tongTiet: acc.tongTiet + (r.tongTiet || 0),
    soLopTN12: acc.soLopTN12 + (r.soLopTN12 || 0), tienTN12: acc.tienTN12 + (r.tienTN12 || 0),
    soLopCN: acc.soLopCN + (r.soLopCN || 0), tienDienThoai: acc.tienDienThoai + (r.tienDienThoai || 0),
  }), { soLopCN: 0, tienDienThoai: 0, tietThuong: 0, tietTC: 0, tien: 0, tietCN1: 0, tietCN2: 0, tongTiet: 0, soLopTN12: 0, tienTN12: 0 });

  // Cột theo từng tab (thứ tự cột Cơ hữu: ... Tiết vượt, Lương cơ bản, Lương hiệu quả, Lương tiết vượt, Tiền TN12, HT ĐT, Tiền).
  const isTGTab = loaiTab !== "cohuu" && loaiTab !== "fulltime";
  const tienOf = (r) => (isTGTab ? tienTGOf(r) : r.tien);
  const sumOf = (k) => rows.reduce((a, r) => a + (Number(r[k]) || 0), 0);
  const money = (v) => (v ? vnd(v) : "—");
  const cSoTuan = { id: "soTuan", label: "Số tuần có TKB", cell: (r) => r.soTuan };
  const cThuong = { id: "tietThuong", label: "Tiết thường", cell: (r) => r.tietThuong, total: () => grand.tietThuong };
  const cTC = { id: "tietTC", label: "Tiết TC", cell: (r) => r.tietTC, total: () => grand.tietTC };
  const cSoLopCN = { id: "soLopCN", label: "Số lớp CN", cell: (r) => r.soLopCN || "—", cellTitle: (r) => [r.lopCN1, r.lopCN2].filter(Boolean).join(", "), total: () => Math.round(grand.soLopCN * 100) / 100 };
  const cHTDT = { id: "htdt", label: "HT ĐT", title: "Hỗ trợ điện thoại GVCN: 200.000 / lớp chủ nhiệm", cell: (r) => money(r.tienDienThoai), total: () => vnd(grand.tienDienThoai) };
  const coiThiCols = rows.some((r) => r.tietCoiThi) ? [
    { id: "tietCoiThi", label: "📝 Khảo sát: tiết coi thi", title: "Tiết coi thi khảo sát (đã ký) — KHÔNG gộp vào tiết thường/tổng tiết", cell: (r) => r.tietCoiThi || "—", total: () => sumOf("tietCoiThi") },
    { id: "tienCoiThi", label: "📝 Khảo sát: tiền coi thi", title: "= Tiết coi thi × đơn giá (Thỉnh giảng 80.000; Cơ hữu = ĐG tiết vượt; FullTime không tính)", cell: (r) => money(r.tienCoiThi), total: () => vnd(sumOf("tienCoiThi")) },
  ] : [];
  const cols0 = loaiTab === "cohuu" ? [
    cSoTuan, cThuong, cTC, cSoLopCN,
    { id: "cn1", label: "Tiết CN Lớp 1", cell: (r) => (r.lopCN1 ? `${r.tietCN1} (${r.lopCN1})` : "—"), total: () => grand.tietCN1 },
    { id: "cn2", label: "Tiết CN Lớp 2", cell: (r) => (r.lopCN2 ? `${r.tietCN2} (${r.lopCN2})` : "—"), total: () => grand.tietCN2 },
    { id: "soLopTN12", label: "Số lớp dạy TN12", cell: (r) => r.soLopTN12 || "—", total: () => grand.soLopTN12 },
    { id: "tongTiet", label: "Tổng số tiết (CK+TC+CN)", cell: (r) => r.tongTiet, total: () => grand.tongTiet },
    { id: "tietChuan", label: "Tiết tiêu chuẩn (4×17)", cell: (r) => r.tietChuan || "—" },
    { id: "tietVuot", label: "Tiết vượt", cell: (r) => (r.tietChuan ? r.tietVuot : "—"), style: (r) => ({ color: r.tietVuot > 0 ? "#0f766e" : r.tietVuot < 0 ? "#dc2626" : undefined }) },
    { id: "dgtv", label: "ĐG tiết vượt", title: "Đơn giá tiết vượt theo thâm niên, tính đến tháng đang xem từ ngày bắt đầu làm việc (tháng bắt đầu = tháng 1): ≤12 tháng = năm 1 = 80.000, >12 tháng = năm 2 = 82.000, >24 tháng = năm 3 = 85.000, >36 tháng = năm 4 = 90.000; không áp dụng thâm niên = 80.000", cell: (r) => (r.tietChuan ? vnd(donGiaTietVuotOf(r)) : "—"), cellTitle: (r) => (r.namThu ? `Năm thứ ${r.namThu} (${r.soThangCongTac} tháng công tác tính đến tháng này)` : "Không áp dụng thâm niên"), style: (r) => ({ fontWeight: donGiaTietVuotOf(r) > DON_GIA_TIET_VUOT ? 700 : undefined, color: donGiaTietVuotOf(r) > DON_GIA_TIET_VUOT ? "#7c3aed" : undefined }) },
    { id: "lcb", label: "Lương cơ bản", cell: (r) => money(r.luongCoBan) },
    { id: "lhq", label: "Lương hiệu quả", cell: (r) => money(r.luongHieuQua) },
    { id: "ltv", label: "Lương tiết vượt", title: "= Tiết vượt × ĐG tiết vượt", cell: (r) => (r.tietChuan ? vnd(luongTietVuotOf(r)) : "—"), total: () => vnd(rows.reduce((a, r) => a + luongTietVuotOf(r), 0)) },
    { id: "tienTN12", label: "Tiền TN12 (×100k)", cell: (r) => money(r.tienTN12), total: () => vnd(grand.tienTN12) },
    cHTDT,
  ] : loaiTab === "fulltime" ? [
    cSoTuan, cThuong, cTC,
    { id: "luongNgayCong", label: "Lương tháng (đủ công)", cell: (r) => vnd(r.luongNgayCong) },
    { id: "congChuan", label: "Ngày công chuẩn", cell: (r) => r.congChuan },
    { id: "congThucTe", label: "Ngày công thực tế", cell: (r) => r.congThucTe, style: () => ({ fontWeight: 700 }) },
    cSoLopCN, cHTDT,
  ] : [
    { id: "tgLevel", label: "Level", title: "Cấp bậc GV Thỉnh giảng (hồ sơ): 2 = dạy lớp 12 môn thi TN (môn ≥ 4 tiết/tuần), 1 = còn lại", cell: (r) => (r.tgLevel ? String(r.tgLevel) : "—"), style: (r) => ({ fontWeight: 700, color: r.tgLevel === 2 ? "#7c3aed" : "#374151" }) },
    cSoTuan, cThuong, cTC,
    { id: "donGiaCK", label: "Đơn giá CK", title: "Đơn giá tiết thường (CK): 80.000đ/tiết", cell: () => vnd(DON_GIA_CK) },
    { id: "donGiaTC", label: "Đơn giá TC", title: "Level 1: 80.000đ/tiết TC, Level 2: 130.000đ/tiết TC (từ 01/09/2026)", cell: (r) => money(r.donGiaTC) },
    { id: "tienCK", label: "Tiền CK", title: "= Tiết thường × Đơn giá CK", cell: (r) => vnd(tienCKOf(r)), total: () => vnd(rows.reduce((a, r) => a + tienCKOf(r), 0)) },
    { id: "tienTC", label: "Tiền TC", title: "= Tiết TC × Đơn giá TC", cell: (r) => vnd(tienTCOf(r)), total: () => vnd(rows.reduce((a, r) => a + tienTCOf(r), 0)) },
  ];
  const cols = [...cols0, ...coiThiCols];

  // Export 3 sheet: Cơ hữu (không gồm FullTime), Thỉnh giảng, FullTime — luôn đủ cả 3 bất kể đang xem tab nào.
  const exportExcel = () => {
    const sum = (list, k) => list.reduce((a, r) => a + (Number(r[k]) || 0), 0);
    const mk = monthLabelOf(monthKey);
    const allRows = data.rows;
    const fullTimeRows = allRows.filter((r) => r.fullTime);
    const tgRows = allRows.filter((r) => !r.fullTime && isThinhGiang(r.loai));
    const chRows = allRows.filter((r) => !r.fullTime && !isThinhGiang(r.loai));
    const base = ["Họ và tên", "Loại", "Số tuần có TKB", "Tiết thường", "Tiết TC"];
    const baseVals = (r) => [r.hoten, r.loai || "", r.soTuan, r.tietThuong, r.tietTC];
    const baseTotal = (list) => ["Tổng cộng", "", "", sum(list, "tietThuong"), sum(list, "tietTC")];
    // Cơ hữu: đủ các trường như cũ + "ĐG tiết vượt" + "Lương tiết vượt"; các cột TÍNH TIỀN dồn về cuối (P..T) để SUM liền nhau.
    // "Tiết vượt", "Lương tiết vượt", "Tiền" xuất kèm CÔNG THỨC Excel (sửa số là tự cập nhật):
    //   N = L-M ; O = ĐG tiết vượt (theo thâm niên) ; R = N*O ; U = SUM(P:T) = Lương cơ bản + Lương hiệu quả + Lương tiết vượt + Tiền TN12 + HT ĐT.
    const chHeader = ["Họ và tên", "Loại", "Số tuần có TKB", "Tiết thường", "Tiết TC", "Số lớp CN", "Tiết CN Lớp 1", "Lớp CN 1", "Tiết CN Lớp 2", "Lớp CN 2", "Số lớp dạy TN12", "Tổng số tiết (CK+TC+CN)", "Tiết tiêu chuẩn (4×17)", "Tiết vượt", "ĐG tiết vượt", "Lương cơ bản", "Lương hiệu quả", "Lương tiết vượt", "Tiền TN12 (×100k)", "HT ĐT", "Tiền"];
    const chRowsX = chRows.map((r, i) => {
      const n = 3 + i; // dòng Excel (dòng 1 tiêu đề, dòng 2 header)
      const ft = r.tietChuan > 0; // đang tính theo công thức Cơ hữu
      const ltv = luongTietVuotOf(r);
      const tien = (Number(r.luongCoBan) || 0) + (Number(r.luongHieuQua) || 0) + ltv + (Number(r.tienTN12) || 0) + (Number(r.tienDienThoai) || 0);
      return [
        r.hoten, r.loai || "", r.soTuan, r.tietThuong, r.tietTC, r.soLopCN || "",
        r.lopCN1 ? r.tietCN1 : "", r.lopCN1 || "", r.lopCN2 ? r.tietCN2 : "", r.lopCN2 || "", r.soLopTN12 || "",
        r.tongTiet, r.tietChuan || "",
        ft ? { formula: `L${n}-M${n}`, result: r.tietVuot } : "",
        ft ? donGiaTietVuotOf(r) : "",
        r.luongCoBan || "", r.luongHieuQua || "",
        ft ? { formula: `N${n}*O${n}`, result: ltv } : "",
        r.tienTN12 || "", r.tienDienThoai || "",
        ft ? { formula: `SUM(P${n}:T${n})`, result: tien } : r.tien,
      ];
    });
    const last = 2 + chRows.length;
    const colSum = (L, k) => (chRows.length ? { formula: `SUM(${L}3:${L}${last})`, result: k() } : 0);
    const sheetCoHuu = {
      title: `Chấm công theo TKB — Cơ hữu — ${mk}`, sheetName: "Cơ hữu", header: chHeader, rows: chRowsX,
      moneyCols: [14, 15, 16, 17, 18, 19, 20],
      totalRow: ["Tổng cộng", "", "", colSum("D", () => sum(chRows, "tietThuong")), colSum("E", () => sum(chRows, "tietTC")), colSum("F", () => sum(chRows, "soLopCN")),
        colSum("G", () => sum(chRows, "tietCN1")), "", colSum("I", () => sum(chRows, "tietCN2")), "", colSum("K", () => sum(chRows, "soLopTN12")), colSum("L", () => sum(chRows, "tongTiet")),
        "", "", "", colSum("P", () => sum(chRows, "luongCoBan")), colSum("Q", () => sum(chRows, "luongHieuQua")), colSum("R", () => chRows.reduce((a, r) => a + luongTietVuotOf(r), 0)),
        colSum("S", () => sum(chRows, "tienTN12")), colSum("T", () => sum(chRows, "tienDienThoai")),
        colSum("U", () => sum(chRows, "tien"))],
    };
    // Thỉnh giảng: A Họ tên, B Loại, C Số tuần, D Tiết thường, E Tiết TC, F Level, G Đơn giá CK, H Đơn giá TC,
    //   I Tiền CK = D*G, J Tiền TC = E*H, K Tiền = I+J (xuất kèm CÔNG THỨC Excel).
    const tgHeader = [...base, "Level", "Đơn giá CK", "Đơn giá TC", "Tiền CK", "Tiền TC", "Tiền"];
    const tgLast = 2 + tgRows.length;
    const tgSum = (L, v) => (tgRows.length ? { formula: `SUM(${L}3:${L}${tgLast})`, result: v } : 0);
    const sheetTG = {
      title: `Chấm công theo TKB — Thỉnh giảng — ${mk}`, sheetName: "Thỉnh giảng", header: tgHeader,
      rows: tgRows.map((r, i) => {
        const n = 3 + i;
        return [...baseVals(r), r.tgLevel ? String(r.tgLevel) : "", DON_GIA_CK, r.donGiaTC || 0,
          { formula: `D${n}*G${n}`, result: tienCKOf(r) }, { formula: `E${n}*H${n}`, result: tienTCOf(r) }, { formula: `I${n}+J${n}`, result: tienTGOf(r) }];
      }),
      moneyCols: [6, 7, 8, 9, 10],
      totalRow: ["Tổng cộng", "", "", tgSum("D", sum(tgRows, "tietThuong")), tgSum("E", sum(tgRows, "tietTC")), "", "", "",
        tgSum("I", tgRows.reduce((a, r) => a + tienCKOf(r), 0)), tgSum("J", tgRows.reduce((a, r) => a + tienTCOf(r), 0)), tgSum("K", tgRows.reduce((a, r) => a + tienTGOf(r), 0))],
    };
    const ftHeader = [...base, "Lương tháng (đủ công)", "Ngày công chuẩn", "Ngày công thực tế", "Số lớp CN", "HT ĐT", "Tiền"];
    const sheetFT = {
      title: `Chấm công — FullTime (tính theo ngày công) — ${mk}`, sheetName: "FullTime", header: ftHeader,
      rows: fullTimeRows.map((r) => [...baseVals(r), r.luongNgayCong, r.congChuan, r.congThucTe, r.soLopCN || "", r.tienDienThoai || "", r.tien]), moneyCols: [5, 9, 10],
      totalRow: [...baseTotal(fullTimeRows), "", "", "", sum(fullTimeRows, "soLopCN"), sum(fullTimeRows, "tienDienThoai"), sum(fullTimeRows, "tien")],
    };
    return exportTableExcel({ fileName: `cham_cong_theo_tkb_${monthKey}.xlsx`, sheets: [sheetCoHuu, sheetTG, sheetFT] });
  };

  // 🖨 In: bảng đang xem (Cơ hữu / Thỉnh giảng / FullTime), khổ A4 ngang, có chỗ ký cuối trang.
  const printList = () => {
    const esc = (x) => String(x ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const tabLabel = String((TU_TKB_LOAI_TABS.find((t) => t.key === loaiTab) || {}).label || "").replace(/^[^\p{L}]+/u, "");
    const head = `<tr><th>STT</th><th>Họ và tên</th><th>Loại</th>${cols.map((c) => `<th>${esc(c.label)}</th>`).join("")}<th>Tiền</th></tr>`;
    const body = rows.map((r, i) => `<tr><td class="c">${i + 1}</td><td class="l b">${esc(r.hoten)}</td><td class="c">${esc(r.loai)}</td>${cols.map((c) => `<td>${esc(c.cell(r))}</td>`).join("")}<td class="b">${esc(vnd(tienOf(r)))}</td></tr>`).join("");
    const foot = `<tr class="tot"><td colspan="3" class="l b">Tổng cộng (${rows.length} người)</td>${cols.map((c) => `<td>${c.total ? esc(c.total()) : ""}</td>`).join("")}<td class="b">${esc(vnd(rows.reduce((a, r) => a + tienOf(r), 0)))}</td></tr>`;
    const html = `<!doctype html><html><head><meta charset="utf-8"><title>Chấm công theo TKB ${esc(monthLabelOf(monthKey))}</title>
<style>@page{size:A4 landscape;margin:10mm}body{font-family:"Times New Roman",serif;font-size:11px;color:#000}
h2{text-align:center;margin:0 0 2px;font-size:16px}.sub{text-align:center;margin:0 0 8px}
table{border-collapse:collapse;width:100%}th,td{border:1px solid #000;padding:3px 4px;text-align:right;vertical-align:middle}
th{background:#eee;text-align:center;font-size:10px}td.l{text-align:left}td.c{text-align:center}.b{font-weight:bold}td:nth-child(2){white-space:nowrap}
tr{page-break-inside:avoid}thead{display:table-header-group}.tot td{background:#f3f3f3}
.sign{display:flex;justify-content:space-around;margin-top:18px;text-align:center}.sign div{width:30%}.sign i{font-weight:normal}</style></head><body>
<div style="font-weight:bold">TRƯỜNG TRUNG CẤP KINH TẾ - KỸ THUẬT PHAN CHU TRINH</div>
<h2>BẢNG CHẤM CÔNG THEO TKB${tabLabel ? ` — ${esc(tabLabel.toUpperCase())}` : ""}</h2><p class="sub">${esc(monthLabelOf(monthKey))}</p>
<table><thead>${head}</thead><tbody>${body}${foot}</tbody></table>
<div class="sign"><div><b>Người lập bảng</b><br><i>(Ký, ghi rõ họ tên)</i></div><div><b>Kế toán</b><br><i>(Ký, ghi rõ họ tên)</i></div><div><i>Ngày ...... tháng ...... năm ${esc(String(monthKey).slice(0, 4))}</i><br><b>Hiệu trưởng</b><br><i>(Ký, ghi rõ họ tên)</i></div></div>
<script>window.onload=function(){setTimeout(function(){window.print()},200)}</script></body></html>`;
    const w = window.open("", "_blank");
    if (!w) { window.alert("Trình duyệt chặn cửa sổ in — cho phép popup rồi bấm lại."); return; }
    w.document.open(); w.document.write(html); w.document.close();
  };

  return (
    <div>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
        Tự tính từ bản TKB <b>đã công bố</b> của từng tuần trong tháng — không qua bảng gõ tay, không cần ai nhập số. Thỉnh giảng được tính tiền theo tiết (tiết thường 80.000; tiết TC theo Level ở hồ sơ: Level 2 — dạy lớp 12 môn thi tốt nghiệp từ 4 tiết/tuần — 130.000, Level 1 — còn lại — 80.000, áp dụng từ 01/09/2026); Cơ hữu hưởng lương cố định theo tháng (Tiết chuẩn 4×17=68 tiết, Tiền = 5.700.000 + 550.000 + Đơn giá × Tiết vượt chuẩn — đơn giá theo thâm niên công tác ở hồ sơ: năm 1 = 80.000, năm 2 = 82.000, năm 3 = 85.000, năm 4 trở lên = 90.000, Tiết vượt = Tiết thường + TC + Tiết CN − 68; Tiết CN = GVCN lớp 1: 2 tiết/tuần, lớp 2: 4 tiết/tuần, nhân số tuần; cộng thêm 100.000 × Số lớp 12 dạy môn thi tốt nghiệp — môn từ 3 tiết/tuần trở lên trong PCCM lớp). Hỗ trợ điện thoại: mỗi lớp chủ nhiệm 200.000 (mọi giáo viên chủ nhiệm, cộng vào Tiền). FullTime (Hà Thị Xuân, Lương Thị Hồng Hạnh) không tính theo tiết: Tiền = Lương tháng × Ngày công thực tế / 26 (nhấn đúp dòng để nhập ngày công). Không gồm nhóm định mức 17 tiết/tuần (xem tab "Chấm công ngoài TKB").
      </p>
      <div style={{ display: "flex", gap: 6, marginBottom: 12, alignItems: "center", flexWrap: "wrap" }}>
        {TU_TKB_LOAI_TABS.map((t) => (
          <button key={t.key} type="button" onClick={() => setLoaiTab(t.key)} style={t.key === loaiTab ? subTabBtnActive : subTabBtnInactive}>
            {t.label} ({data.rows.filter((r) => tkbGroupOf(r) === t.key).length})
          </button>
        ))}
        <span style={{ marginLeft: "auto", display: "flex", gap: 6 }}>
          <button type="button" onClick={printList} disabled={rows.length === 0} style={{ padding: "5px 12px", border: "1px solid #374151", borderRadius: 6, background: "#fff", color: "#374151", cursor: rows.length ? "pointer" : "not-allowed", fontSize: 13, fontWeight: 600 }}>🖨 In</button>
          <ExportBtn onClick={exportExcel} disabled={data.rows.length === 0} />
        </span>
      </div>
      {rows.length === 0 ? (
        <p style={{ color: "#6b7280" }}>Không có GV nào thuộc nhóm này trong tháng.</p>
      ) : (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8 }}>
          <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%" }}>
            <thead>
              <tr>
                <th style={{ ...th, textAlign: "left" }}>Họ và tên</th>
                <th style={th}>Loại</th>
                {cols.map((c) => (<th key={c.id} style={th} title={c.title}>{c.label}</th>))}
                <th style={th} title={loaiTab === "thinhgiang" ? "= Tiền CK + Tiền TC" : undefined}>Tiền</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.staffId || i} onDoubleClick={() => setDetailRow(r)} title="Nhấn đúp để xem chi tiết / sửa" style={{ cursor: "pointer" }}>
                  <td style={{ ...td, textAlign: "left", fontWeight: 600 }}>
                    {r.hoten}
                    {r.daChinh && <span title="Có chỉnh thông số lương" style={{ marginLeft: 6, color: "#b45309", fontSize: 12 }}>✎ đã chỉnh</span>}
                    {r.gopTuThangSau && <span title={`Gồm ${(r.gopTuThangSau.tietThuong || 0) + (r.gopTuThangSau.tietTC || 0)} tiết của tháng ${Number(String(r.gopTuThangSau.thang).slice(5))} (đã gộp vào tháng này)`} style={{ marginLeft: 6, color: "#0f766e", fontSize: 12 }}>⤴ +{(r.gopTuThangSau.tietThuong || 0) + (r.gopTuThangSau.tietTC || 0)} tiết T{Number(String(r.gopTuThangSau.thang).slice(5))}</span>}
                  </td>
                  <td style={td}>{r.loai}</td>
                  {cols.map((c) => (<td key={c.id} style={{ ...td, ...(c.style ? c.style(r) : {}) }} title={c.cellTitle ? c.cellTitle(r) : undefined} onClick={c.onClick ? (e) => { e.stopPropagation(); c.onClick(r); } : undefined} onDoubleClick={c.onClick ? (e) => e.stopPropagation() : undefined}>{c.cell(r)}</td>))}
                  <td style={{ ...td, fontWeight: tienOf(r) > 0 ? 700 : 400, color: tienOf(r) > 0 ? "#047857" : "#9ca3af" }}>{vnd(tienOf(r))}</td>
                </tr>
              ))}
              <tr>
                <td style={{ ...td, textAlign: "left", fontWeight: 700, background: "#ecfdf5" }} colSpan={2}>Tổng cộng</td>
                {cols.map((c) => (<td key={c.id} style={{ ...td, fontWeight: 700, background: "#ecfdf5" }}>{c.total ? c.total() : ""}</td>))}
                <td style={{ ...td, fontWeight: 700, fontSize: 15, color: "#047857", background: "#ecfdf5" }}>{vnd(rows.reduce((a, r) => a + tienOf(r), 0))}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
      {detailRow && (
        <TuTkbDetailDialog
          key={detailRow.staffId}
          row={detailRow}
          schoolId={schoolId}
          monthKey={monthKey}
          onClose={() => setDetailRow(null)}
          onSaved={() => { setDetailRow(null); setReloadKey((k) => k + 1); }}
        />
      )}
    </div>
  );
};

// Tab con "Tổng hợp" của Khảo sát — KHÔNG lấy số Tổng có sẵn trong Excel gốc
// (Excel tính sai, vd cộng nhầm dòng "Đã chuyển công tác" vào tổng sheet dù
// không được tính cho người đó) — tự cộng lại Thực nhận theo người trên cả 3
// bảng đã công bố (tính ở server, xem routes/khao-sat.js).
const KhaoSatTongHopTab = ({ schoolId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!schoolId) return;
    setLoading(true);
    setError("");
    getKhaoSatTongHop(schoolId).then(setData).catch((e) => setError(e.message)).finally(() => setLoading(false));
  }, [schoolId]);

  if (loading) return <p>Đang tải...</p>;
  if (error) return <p style={{ color: "#dc2626" }}>{error}</p>;
  if (!data) return null;

  const { labels, rows, grandTotal } = data;
  const lanKeys = Object.keys(labels);
  const exportExcel = () => {
    const header = ["Họ và tên", ...lanKeys.map((k) => labels[k]), "Tổng"];
    const rowsX = rows.map((r) => [r.hoten, ...lanKeys.map((k) => Number(r.byLan[k]) || 0), Number(r.tong) || 0]);
    const moneyCols = header.map((_, i) => i).slice(1);
    return exportTableExcel({ title: "Khảo sát — Tổng hợp thực nhận", sheetName: "Khảo sát tổng hợp", fileName: "khao_sat_tong_hop.xlsx", header, rows: rowsX, moneyCols, totalRow: ["Tổng cộng", ...lanKeys.map((k) => rows.reduce((s, r) => s + (Number(r.byLan[k]) || 0), 0)), Number(grandTotal) || 0] });
  };

  return (
    <div>
      <div style={{ marginBottom: 10 }}><ExportBtn onClick={exportExcel} disabled={rows.length === 0} /></div>
      <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
        Tự cộng Thực nhận theo từng người trên cả 3 bảng <b>đã công bố</b> — không lấy số Tổng có sẵn trong file Excel.
        Dòng có "Loại HĐLĐ" là <b>Đã chuyển công tác</b> không được cộng.
      </p>
      {rows.length === 0 ? (
        <p style={{ color: "#6b7280" }}>Chưa có bảng nào được công bố.</p>
      ) : (
        <div style={{ overflowX: "auto", border: "1px solid #e5e7eb", borderRadius: 8 }}>
          <table style={{ borderCollapse: "collapse", fontSize: 13, width: "100%" }}>
            <thead>
              <tr>
                <th style={{ ...th, textAlign: "left" }}>Họ và tên</th>
                {lanKeys.map((k) => (<th key={k} style={th}>{labels[k]}</th>))}
                <th style={th}>Tổng</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.hoten}>
                  <td style={{ ...td, textAlign: "left", fontWeight: 600 }}>{r.hoten}</td>
                  {lanKeys.map((k) => (<td key={k} style={td}>{r.byLan[k] > 0 ? `${vnd(r.byLan[k])}` : "—"}</td>))}
                  <td style={{ ...td, fontWeight: 700, color: "#047857" }}>{vnd(r.tong)}</td>
                </tr>
              ))}
              <tr>
                <td style={{ ...td, textAlign: "left", fontWeight: 700, background: "#ecfdf5" }} colSpan={lanKeys.length + 1}>Tổng cộng</td>
                <td style={{ ...td, fontWeight: 700, fontSize: 15, color: "#047857", background: "#ecfdf5" }}>{vnd(grandTotal)}</td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

// Tab "Khảo sát" — không theo tháng TKB, đứng độc lập ngay trong trang này
// (mỗi sheet Excel gốc = 1 tab con, riêng "Tổng hợp" tự tính ở server).
const KhaoSatTab = ({ schoolId }) => {
  const [inner, setInner] = useState(KHAO_SAT_INNER_TABS[0].key);
  return (
    <div>
      <div style={{ display: "flex", gap: 6, marginBottom: 12 }}>
        {KHAO_SAT_INNER_TABS.map((t) => (
          <button key={t.key} type="button" onClick={() => setInner(t.key)} style={t.key === inner ? subTabBtnActive : subTabBtnInactive}>
            {t.label}
          </button>
        ))}
      </div>
      {inner === "tonghop" ? (
        <KhaoSatTongHopTab schoolId={schoolId} />
      ) : (
        <HappySchoolDataTable key={inner} tableKey={inner} config={KHAO_SAT_CFG[inner]} />
      )}
    </div>
  );
};

// "Chấm công tháng — GV Văn hoá" — chức năng riêng, ngang hàng với "Xếp thời
// khoá biểu" (trước đây nằm lồng trong đó). Mỗi tháng có tuần TKB thật là 1
// mục chọn, bên trong có tab Xem chấm công (bảng gõ tay, sửa/xuất Excel) và
// Thu nhập (tính thực nhận từng người, để admin duyệt trước khi trả lương).
// Tab "Khảo sát" KHÔNG theo tháng nên hiện được luôn, không cần chọn tháng.
const HappySchoolChamCongThang = () => {
  const schoolId = getActiveSchoolId();
  const [weeks, setWeeks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [subTab, setSubTab] = useState("chamcong");
  // Công bố lương theo THÁNG: chưa công bố thì GV chỉ xem được số tiết, không thấy lương/thu nhập.
  const [pubMap, setPubMap] = useState({});
  const [pubBusy, setPubBusy] = useState(false);
  useEffect(() => {
    if (!schoolId) return;
    getChamCongThangPublish(schoolId).then((d) => setPubMap(d.months || {})).catch(() => setPubMap({}));
  }, [schoolId]);
  const togglePublish = async (mk) => {
    const dang = !!(pubMap[mk] && pubMap[mk].published);
    const msg = dang
      ? `Thu hồi công bố ${monthLabelOf(mk)}? Giáo viên sẽ chỉ xem được số tiết, không xem được lương/thu nhập tháng này.`
      : `Công bố lương ${monthLabelOf(mk)} cho toàn bộ giáo viên/nhân viên? Họ sẽ xem được lương và thu nhập của mình ngay.`;
    if (!window.confirm(msg)) return;
    setPubBusy(true);
    try {
      const r = await setChamCongThangPublish(schoolId, mk, !dang);
      setPubMap((m) => ({ ...m, [mk]: { published: r.published, at: r.at, byUid: r.byUid } }));
    } catch (e) {
      window.alert(e.message || "Không lưu được.");
    } finally { setPubBusy(false); }
  };

  useEffect(() => {
    if (!schoolId) return;
    setLoading(true);
    setError("");
    listTimetableWeeks(schoolId)
      .then((list) => {
        setWeeks(list || []);
        const byMonth = {};
        (list || []).forEach((w) => { byMonth[monthKeyOf(w.startDate)] = true; });
        const monthKeys = Object.keys(byMonth).sort();
        if (monthKeys.length) setSelectedMonth(monthKeys[monthKeys.length - 1]);
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [schoolId]);

  if (!schoolId) return <p style={{ color: "#6b7280" }}>Chưa chọn trường.</p>;
  if (loading) return <p>Đang tải...</p>;
  if (error) return <p style={{ color: "#dc2626" }}>{error}</p>;

  const weeksByMonth = {};
  weeks.forEach((w) => {
    const mk = monthKeyOf(w.startDate);
    (weeksByMonth[mk] = weeksByMonth[mk] || []).push(w);
  });
  const monthKeys = Object.keys(weeksByMonth).sort();
  monthKeys.forEach((mk) => weeksByMonth[mk].sort((a, b) => (a.startDate || "").localeCompare(b.startDate || "")));

  return (
    <div style={{ display: "flex", gap: 16, alignItems: "flex-start", flexWrap: "wrap" }}>
      <div style={{ width: 220, flexShrink: 0, background: "#fff", border: "1px solid #e5e7eb", borderRadius: 10, padding: 12, boxSizing: "border-box" }}>
        {monthKeys.length === 0 ? (
          <p style={{ color: "#9ca3af", fontSize: 13 }}>Chưa có tuần TKB nào.</p>
        ) : (
          monthKeys.map((mk) => (
            <div
              key={mk}
              onClick={() => setSelectedMonth(mk)}
              style={mk === selectedMonth ? monthNodeActive : monthNode}
            >
              📅 {monthLabelOf(mk)}{" "}
              <span title={pubMap[mk] && pubMap[mk].published ? "Đã công bố lương" : "Chưa công bố lương"}>{pubMap[mk] && pubMap[mk].published ? "✅" : "🔒"}</span>
            </div>
          ))
        )}
      </div>
      <div style={{ flex: 1, minWidth: 320 }}>
        <h3 style={{ margin: "0 0 12px" }}>🧾 Chấm công tháng — GV Văn hoá</h3>
        <div style={{ display: "flex", gap: 6, marginBottom: 16, borderBottom: "1px solid #e5e7eb" }}>
          {SUB_TABS.map((t) => (
            <button key={t.key} type="button" onClick={() => setSubTab(t.key)} style={t.key === subTab ? tabBtnActive : tabBtnInactive}>
              {t.label}
            </button>
          ))}
        </div>
        {subTab === "khaosat" ? (
          <KhaoSatTab schoolId={schoolId} />
        ) : subTab === "ngoaitkb" ? (
          <div>
            <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
              GV không nằm trong TKB K12 (dạy lớp Nghề/CNTT như Photoshop, Flash, Lắp ráp máy tính...) — chấm công theo TỪNG BUỔI DẠY thực tế, không suy từ thời khoá biểu.
            </p>
            <p style={{ color: "#6b7280", fontSize: 13, margin: "0 0 8px" }}>{selectedMonth ? monthLabelOf(selectedMonth) : monthLabelOf("2026-08")} — chọn tháng ở bên trái.</p>
            <HappySchoolDataTable key={ngoaiTkbKeyForMonth(selectedMonth)} tableKey={ngoaiTkbKeyForMonth(selectedMonth)} config={CHAMCONG_NGOAI_TKB_CFG} />
            <NgoaiTkbTongTheoGV key={"tong-" + ngoaiTkbKeyForMonth(selectedMonth)} schoolId={schoolId} tableKey={ngoaiTkbKeyForMonth(selectedMonth)} label={selectedMonth ? monthLabelOf(selectedMonth) : monthLabelOf("2026-08")} />
          </div>
        ) : !selectedMonth ? (
          <p style={{ color: "#6b7280" }}>Chọn 1 tháng ở bên trái.</p>
        ) : (
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap", marginTop: -8, marginBottom: 12 }}>
              <span style={{ color: "#6b7280", fontSize: 13 }}>{monthLabelOf(selectedMonth)}</span>
              {pubMap[selectedMonth] && pubMap[selectedMonth].published ? (
                <span style={{ fontSize: 12, color: "#047857", background: "#ecfdf5", border: "1px solid #a7f3d0", borderRadius: 12, padding: "2px 10px" }}>
                  ✅ Đã công bố{pubMap[selectedMonth].at ? ` ${new Date(pubMap[selectedMonth].at).toLocaleString("vi-VN")}` : ""} — GV xem được lương/thu nhập
                </span>
              ) : (
                <span style={{ fontSize: 12, color: "#92400e", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: 12, padding: "2px 10px" }}>
                  🔒 Chưa công bố — GV chỉ xem được số tiết dạy
                </span>
              )}
              <button type="button" disabled={pubBusy} onClick={() => togglePublish(selectedMonth)}
                style={pubMap[selectedMonth] && pubMap[selectedMonth].published ? dlgBtnGhost : dlgBtnPrimary}>
                {pubMap[selectedMonth] && pubMap[selectedMonth].published ? "Thu hồi công bố" : "📢 Công bố tháng này"}
              </button>
            </div>
            <HappySchoolPublishLog key={`log_${selectedMonth}_${pubMap[selectedMonth] ? pubMap[selectedMonth].at : 0}`} schoolId={schoolId} kind="luong" monthKey={selectedMonth} title={`📜 Nhật ký công bố lương ${monthLabelOf(selectedMonth)}`} />
            {subTab === "chamcong" ? (
              <div>
                <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>Gộp các tuần trong tháng, sửa/nhập/xuất Excel được.</p>
                <HappySchoolDataTable
                  key={selectedMonth}
                  tableKey={tableKeyForMonth(selectedMonth)}
                  config={buildMonthChamCongCfg(selectedMonth, weeksByMonth[selectedMonth] || [])}
                />
              </div>
            ) : subTab === "tutkb" ? (
              <ChamCongTuTkbTab key={selectedMonth} schoolId={schoolId} monthKey={selectedMonth} />
            ) : subTab === "nghe" ? (
              <ChamCongNgheTab key={selectedMonth} schoolId={schoolId} monthKey={selectedMonth} />
            ) : subTab === "congdaotao" ? (
              <CongDaoTaoTab key={selectedMonth} schoolId={schoolId} monthKey={selectedMonth} />
            ) : subTab === "antrua" ? (
              <AnTruaTab key={selectedMonth} schoolId={schoolId} monthKey={selectedMonth} />
            ) : subTab === "tamung" || subTab === "qtkd" ? (
              <BangChuyenKhoanTab key={`${subTab}_${selectedMonth}`} cfg={BANG_CK[subTab]} schoolId={schoolId} monthKey={selectedMonth} />
            ) : subTab === "kiemxe" ? (
              <KiemXeTab key={selectedMonth} schoolId={schoolId} monthKey={selectedMonth} />
            ) : subTab === "thunhapthpt" ? (
              <ThuNhapThptTab key={selectedMonth} schoolId={schoolId} monthKey={selectedMonth} />
            ) : subTab === "thunhapnghe" ? (
              <ThuNhapNgheTab key={selectedMonth} schoolId={schoolId} monthKey={selectedMonth} />
            ) : subTab === "daotaonghe" ? (
              <DaoTaoNgheTab key={selectedMonth} schoolId={schoolId} monthKey={selectedMonth} />
            ) : subTab === "treoluong" ? (
              <ThuNhapAdminTab key={`treo_${selectedMonth}`} schoolId={schoolId} monthKey={selectedMonth} treoMode />
            ) : (
              <ThuNhapAdminTab key={selectedMonth} schoolId={schoolId} monthKey={selectedMonth} />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const monthNode = { padding: "8px 10px", borderRadius: 8, cursor: "pointer", fontSize: 14, marginBottom: 2 };
const monthNodeActive = { ...monthNode, background: "#0ea5a3", color: "#fff", fontWeight: 700 };
const tabBtnBase = { padding: "8px 14px", border: "none", borderBottom: "2px solid transparent", background: "transparent", cursor: "pointer", fontSize: 14, fontWeight: 600, color: "#6b7280" };
const tabBtnActive = { ...tabBtnBase, color: "#0f766e", borderBottomColor: "#0f766e" };
const tabBtnInactive = tabBtnBase;
const subTabBtnBase = { padding: "5px 10px", border: "1px solid #d1d5db", borderRadius: 16, background: "#fff", cursor: "pointer", fontSize: 12, fontWeight: 600, color: "#6b7280" };
const subTabBtnActive = { ...subTabBtnBase, background: "#0ea5a3", borderColor: "#0ea5a3", color: "#fff" };
const subTabBtnInactive = subTabBtnBase;
const dlgOverlay = { position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 16 };
const dlgBox = { background: "#fff", borderRadius: 12, padding: 20, width: "100%", maxWidth: 460, maxHeight: "90vh", overflowY: "auto", boxSizing: "border-box" };
const dlgBtnPrimary = { padding: "8px 18px", background: "#0ea5a3", color: "#fff", border: "none", borderRadius: 8, cursor: "pointer", fontWeight: 600 };
const dlgBtnGhost = { padding: "8px 18px", background: "#fff", color: "#374151", border: "1px solid #d1d5db", borderRadius: 8, cursor: "pointer", fontWeight: 600 };
const th = { border: "1px solid #e5e7eb", padding: "6px 8px", background: "#f9fafb", whiteSpace: "nowrap", textAlign: "center" };
const td = { border: "1px solid #e5e7eb", padding: "6px 8px", textAlign: "center" };

export default HappySchoolChamCongThang;
